var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPiano(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 225",
    height: 300,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "id1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10.0625 22.523438 L 61 22.523438 L 61 195.625 L 10.0625 195.625 Z M 10.0625 22.523438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10.070312 22.523438 L 60.457031 22.523438 L 60.457031 195.542969 L 10.070312 195.542969 Z M 10.070312 22.523438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 60.457031 182.726562 L 60.457031 24.105469 C 60.457031 23.566406 60.421875 23.042969 60.375 22.523438 L 10.15625 22.523438 C 10.105469 23.042969 10.070312 23.566406 10.070312 24.105469 L 10.070312 182.726562 C 10.070312 189.804688 14.699219 195.542969 20.402344 195.542969 L 50.125 195.542969 C 55.832031 195.542969 60.457031 189.804688 60.457031 182.726562 Z M 59.269531 182.726562 C 59.269531 189.136719 55.167969 194.355469 50.125 194.355469 L 20.402344 194.355469 C 15.359375 194.355469 11.257812 189.136719 11.257812 182.726562 L 11.257812 24.105469 C 11.257812 23.980469 11.257812 23.84375 11.261719 23.710938 L 59.265625 23.710938 C 59.269531 23.84375 59.269531 23.980469 59.269531 24.105469 L 59.269531 182.726562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 60.457031 182.726562 L 60.457031 24.105469 C 60.457031 23.566406 60.421875 23.042969 60.375 22.523438 L 10.15625 22.523438 C 10.105469 23.042969 10.070312 23.566406 10.070312 24.105469 L 10.070312 182.726562 C 10.070312 189.804688 14.699219 195.542969 20.402344 195.542969 L 50.125 195.542969 C 55.832031 195.542969 60.457031 189.804688 60.457031 182.726562 Z M 59.269531 182.726562 C 59.269531 189.136719 55.167969 194.355469 50.125 194.355469 L 20.402344 194.355469 C 15.359375 194.355469 11.257812 189.136719 11.257812 182.726562 L 11.257812 24.105469 C 11.257812 23.980469 11.257812 23.84375 11.261719 23.710938 L 59.265625 23.710938 C 59.269531 23.84375 59.269531 23.980469 59.269531 24.105469 L 59.269531 182.726562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 4.74786e-9,
    gradientTransform: "matrix(0.000000000000010594, 173.01823, -173.01823, 0.000000000000010594, 35.263947, 22.52483)",
    y1: 0,
    x2: 0.999992,
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    id: "id5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.498535%, 12.89978%, 27.49939%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.498535%, 12.89978%, 27.49939%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.498535%, 12.89978%, 27.49939%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.298645%, 12.69989%, 27.2995%)",
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.098755%, 12.5%, 27.099609%)",
    offset: 0.148437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.086548%, 12.5%, 26.899719%)",
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.074341%, 12.5%, 26.699829%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.883606%, 12.348938%, 26.498413%)",
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.694397%, 12.199402%, 26.298523%)",
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.546387%, 12.199402%, 26.104736%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.198486%, 12.199402%, 25.721741%)",
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.998596%, 12.199402%, 25.531006%)",
    offset: 0.179687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.82312%, 11.999512%, 25.340271%)",
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.64917%, 11.799622%, 25.149536%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.42334%, 11.782837%, 24.923706%)",
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 11.767578%, 24.699402%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.192932%, 11.582947%, 24.499512%)",
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.186829%, 11.399841%, 24.299622%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.993042%, 11.399841%, 24.299622%)",
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.599365%, 11.212158%, 24.099731%)",
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.399475%, 11.024475%, 23.899841%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.220947%, 11.010742%, 23.698425%)",
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.042419%, 10.998535%, 23.498535%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.821167%, 10.980225%, 23.280334%)",
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.599915%, 10.961914%, 23.062134%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.589233%, 10.780334%, 22.872925%)",
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.389343%, 10.598755%, 22.541809%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.998718%, 10.40802%, 22.209167%)",
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.798828%, 10.218811%, 22.018433%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.617249%, 10.20813%, 21.827698%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.217468%, 10.177612%, 21.417236%)",
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.999268%, 10.15625%, 21.199036%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.987061%, 9.977722%, 20.999146%)",
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.974854%, 9.799194%, 20.799255%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.78717%, 9.799194%, 20.599365%)",
    offset: 0.285156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.599487%, 9.799194%, 20.399475%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.453003%, 9.605408%, 20.399475%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.118835%, 9.405518%, 20.199585%)",
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.931152%, 9.399414%, 19.999695%)",
    offset: 0.304687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.914368%, 9.399414%, 19.799805%)",
    offset: 0.308594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.899109%, 9.399414%, 19.599915%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.699219%, 9.199524%, 19.398499%)",
    offset: 0.316406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.499329%, 8.999634%, 19.198608%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.299438%, 8.999634%, 18.998718%)",
    offset: 0.324219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.099548%, 8.999634%, 18.798828%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.90271%, 8.802795%, 18.60199%)",
    offset: 0.332031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.705872%, 8.605957%, 18.405151%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.70282%, 8.602905%, 18.214417%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.499878%, 8.599854%, 18.011475%)",
    offset: 0.347656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.299988%, 8.599854%, 17.999268%)",
    offset: 0.351563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.098572%, 8.398438%, 17.785645%)",
    offset: 0.355469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.898682%, 8.198547%, 17.572021%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.889526%, 8.198547%, 17.425537%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.689636%, 7.998657%, 17.089844%)",
    offset: 0.371094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.498901%, 7.800293%, 16.899109%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.308167%, 7.798767%, 16.708374%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.108276%, 7.798767%, 16.326904%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.899231%, 7.649231%, 16.096497%)",
    offset: 0.394531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.699341%, 7.499695%, 16.055298%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.499451%, 7.499695%, 15.864563%)",
    offset: 0.402344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.299561%, 7.499695%, 15.673828%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.296509%, 7.299805%, 15.486145%)",
    offset: 0.410156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.293457%, 7.099915%, 15.299988%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.096619%, 7.099915%, 15.106201%)",
    offset: 0.417969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.89978%, 7.099915%, 14.912415%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.715149%, 7.099915%, 14.72168%)",
    offset: 0.429687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.515259%, 6.924438%, 14.51416%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.348938%, 6.723022%, 14.283752%)",
    offset: 0.441406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.199402%, 6.698608%, 14.068604%)",
    offset: 0.445313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.999512%, 6.692505%, 13.883972%)",
    offset: 0.449219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.799622%, 6.686401%, 13.699341%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.799622%, 6.492615%, 13.502502%)",
    offset: 0.457031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.799622%, 6.298828%, 13.305664%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.599731%, 6.298828%, 13.114929%)",
    offset: 0.464844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.399841%, 6.298828%, 12.924194%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.399841%, 6.298828%, 12.911987%)",
    offset: 0.476563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.198425%, 6.098938%, 12.684631%)",
    offset: 0.480469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.998535%, 5.899048%, 12.471008%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.798645%, 5.899048%, 12.335205%)",
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.598755%, 5.899048%, 12.199402%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.598755%, 5.699158%, 11.999512%)",
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.598755%, 5.499268%, 11.799622%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.398865%, 5.499268%, 11.799622%)",
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.198975%, 5.499268%, 11.799622%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.198975%, 5.499268%, 11.599731%)",
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.198975%, 5.499268%, 11.399841%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.999084%, 5.299377%, 11.198425%)",
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.799194%, 5.099487%, 10.998535%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.599304%, 5.099487%, 10.798645%)",
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.399414%, 5.099487%, 10.598755%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.399414%, 5.099487%, 10.595703%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.205627%, 4.905701%, 10.395813%)",
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.011841%, 4.711914%, 10.198975%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.005737%, 4.705811%, 10.014343%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.799744%, 4.699707%, 9.814453%)",
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.599854%, 4.699707%, 9.799194%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.583069%, 4.499817%, 9.584045%)",
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.56781%, 4.299927%, 9.368896%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.383179%, 4.299927%, 9.184265%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.198547%, 4.299927%, 8.802795%)",
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.198547%, 4.299927%, 8.605957%)",
    offset: 0.585937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.998657%, 4.112244%, 8.602905%)",
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.798767%, 3.924561%, 8.599854%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.798767%, 3.910828%, 8.398438%)",
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.798767%, 3.898621%, 8.198547%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.649231%, 3.898621%, 7.998657%)",
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.499695%, 3.898621%, 7.798767%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.49054%, 3.889465%, 7.791138%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.290649%, 3.689575%, 7.641602%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.099915%, 3.49884%, 7.499695%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.898499%, 3.49884%, 7.299805%)",
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.698608%, 3.49884%, 7.099915%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.677246%, 3.29895%, 6.898499%)",
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.655884%, 3.09906%, 6.698608%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.477356%, 3.09906%, 6.686401%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.298828%, 3.09906%, 6.486511%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.105042%, 2.905273%, 6.105042%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.731201%, 2.705383%, 5.731201%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.523682%, 2.687073%, 5.508423%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.493164%, 2.537537%, 5.284119%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.293274%, 2.398682%, 5.099487%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.099487%, 2.398682%, 4.899597%)",
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.099487%, 2.398682%, 4.699707%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.920959%, 2.398682%, 4.699707%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.721069%, 2.198792%, 4.499817%)",
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.699707%, 1.998901%, 4.299927%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.699707%, 1.998901%, 4.290771%)",
    offset: 0.742187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.499817%, 1.998901%, 4.089355%)",
    offset: 0.746094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.299927%, 1.998901%, 3.898621%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.299927%, 1.998901%, 3.898621%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.299927%, 1.817322%, 3.69873%)",
    offset: 0.761719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.299927%, 1.637268%, 3.49884%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.098511%, 1.617432%, 3.477478%)",
    offset: 0.769531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.898621%, 1.599121%, 3.456116%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.898621%, 1.599121%, 3.277588%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.898621%, 1.599121%, 3.09906%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.70636%, 1.599121%, 2.906799%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.50647%, 1.411438%, 2.706909%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.495789%, 1.211548%, 2.548218%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.297424%, 1.199341%, 2.398682%)",
    offset: 0.835937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.100586%, 1.199341%, 2.398682%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.09906%, 1.199341%, 2.2995%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.09906%, 1.199341%, 2.099609%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.09906%, 1.098633%, 1.998901%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.09906%, 0.898743%, 1.998901%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 60 22.410156 L 111 22.410156 L 111 195.625 L 60 195.625 Z M 60 22.410156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 60.457031 22.523438 L 110.847656 22.523438 L 110.847656 195.542969 L 60.457031 195.542969 Z M 60.457031 22.523438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 110.847656 182.726562 L 110.847656 24.105469 C 110.847656 23.566406 110.808594 23.042969 110.765625 22.523438 L 60.546875 22.523438 C 60.492188 23.042969 60.457031 23.566406 60.457031 24.105469 L 60.457031 182.726562 C 60.457031 189.804688 65.089844 195.542969 70.792969 195.542969 L 100.507812 195.542969 C 106.21875 195.542969 110.847656 189.804688 110.847656 182.726562 Z M 109.660156 182.726562 C 109.660156 189.136719 105.558594 194.355469 100.507812 194.355469 L 70.792969 194.355469 C 65.746094 194.355469 61.644531 189.136719 61.644531 182.726562 L 61.644531 24.105469 C 61.644531 23.980469 61.648438 23.84375 61.652344 23.710938 L 109.65625 23.710938 C 109.660156 23.84375 109.660156 23.980469 109.660156 24.105469 L 109.660156 182.726562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 110.847656 182.726562 L 110.847656 24.105469 C 110.847656 23.566406 110.808594 23.042969 110.765625 22.523438 L 60.546875 22.523438 C 60.492188 23.042969 60.457031 23.566406 60.457031 24.105469 L 60.457031 182.726562 C 60.457031 189.804688 65.089844 195.542969 70.792969 195.542969 L 100.507812 195.542969 C 106.21875 195.542969 110.847656 189.804688 110.847656 182.726562 Z M 109.660156 182.726562 C 109.660156 189.136719 105.558594 194.355469 100.507812 194.355469 L 70.792969 194.355469 C 65.746094 194.355469 61.644531 189.136719 61.644531 182.726562 L 61.644531 24.105469 C 61.644531 23.980469 61.648438 23.84375 61.652344 23.710938 L 109.65625 23.710938 C 109.660156 23.84375 109.660156 23.980469 109.660156 24.105469 L 109.660156 182.726562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 4.74786e-9,
    gradientTransform: "matrix(0.000000000000010594, 173.01823, -173.01823, 0.000000000000010594, 85.652863, 22.52483)",
    y1: 0,
    x2: 0.999992,
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    id: "id10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.498535%, 12.89978%, 27.49939%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.498535%, 12.89978%, 27.49939%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.498535%, 12.89978%, 27.49939%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.298645%, 12.69989%, 27.2995%)",
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.098755%, 12.5%, 27.099609%)",
    offset: 0.148437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.086548%, 12.5%, 26.899719%)",
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.074341%, 12.5%, 26.699829%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.883606%, 12.348938%, 26.498413%)",
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.694397%, 12.199402%, 26.298523%)",
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.546387%, 12.199402%, 26.104736%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.198486%, 12.199402%, 25.721741%)",
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.998596%, 12.199402%, 25.531006%)",
    offset: 0.179687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.82312%, 11.999512%, 25.340271%)",
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.64917%, 11.799622%, 25.149536%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.42334%, 11.782837%, 24.923706%)",
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 11.767578%, 24.699402%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.192932%, 11.582947%, 24.499512%)",
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.186829%, 11.399841%, 24.299622%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.993042%, 11.399841%, 24.299622%)",
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.599365%, 11.212158%, 24.099731%)",
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.399475%, 11.024475%, 23.899841%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.220947%, 11.010742%, 23.698425%)",
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.042419%, 10.998535%, 23.498535%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.821167%, 10.980225%, 23.280334%)",
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.599915%, 10.961914%, 23.062134%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.589233%, 10.780334%, 22.872925%)",
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.389343%, 10.598755%, 22.541809%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.998718%, 10.40802%, 22.209167%)",
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.798828%, 10.218811%, 22.018433%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.617249%, 10.20813%, 21.827698%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.217468%, 10.177612%, 21.417236%)",
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.999268%, 10.15625%, 21.199036%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.987061%, 9.977722%, 20.999146%)",
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.974854%, 9.799194%, 20.799255%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.78717%, 9.799194%, 20.599365%)",
    offset: 0.285156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.599487%, 9.799194%, 20.399475%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.453003%, 9.605408%, 20.399475%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.118835%, 9.405518%, 20.199585%)",
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.931152%, 9.399414%, 19.999695%)",
    offset: 0.304687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.914368%, 9.399414%, 19.799805%)",
    offset: 0.308594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.899109%, 9.399414%, 19.599915%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.699219%, 9.199524%, 19.398499%)",
    offset: 0.316406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.499329%, 8.999634%, 19.198608%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.299438%, 8.999634%, 18.998718%)",
    offset: 0.324219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.099548%, 8.999634%, 18.798828%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.90271%, 8.802795%, 18.60199%)",
    offset: 0.332031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.705872%, 8.605957%, 18.405151%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.70282%, 8.602905%, 18.214417%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.499878%, 8.599854%, 18.011475%)",
    offset: 0.347656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.299988%, 8.599854%, 17.999268%)",
    offset: 0.351563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.098572%, 8.398438%, 17.785645%)",
    offset: 0.355469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.898682%, 8.198547%, 17.572021%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.889526%, 8.198547%, 17.425537%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.689636%, 7.998657%, 17.089844%)",
    offset: 0.371094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.498901%, 7.800293%, 16.899109%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.308167%, 7.798767%, 16.708374%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.108276%, 7.798767%, 16.326904%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.899231%, 7.649231%, 16.096497%)",
    offset: 0.394531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.699341%, 7.499695%, 16.055298%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.499451%, 7.499695%, 15.864563%)",
    offset: 0.402344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.299561%, 7.499695%, 15.673828%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.296509%, 7.299805%, 15.486145%)",
    offset: 0.410156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.293457%, 7.099915%, 15.299988%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.096619%, 7.099915%, 15.106201%)",
    offset: 0.417969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.89978%, 7.099915%, 14.912415%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.715149%, 7.099915%, 14.72168%)",
    offset: 0.429687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.515259%, 6.924438%, 14.51416%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.348938%, 6.723022%, 14.283752%)",
    offset: 0.441406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.199402%, 6.698608%, 14.068604%)",
    offset: 0.445313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.999512%, 6.692505%, 13.883972%)",
    offset: 0.449219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.799622%, 6.686401%, 13.699341%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.799622%, 6.492615%, 13.502502%)",
    offset: 0.457031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.799622%, 6.298828%, 13.305664%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.599731%, 6.298828%, 13.114929%)",
    offset: 0.464844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.399841%, 6.298828%, 12.924194%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.399841%, 6.298828%, 12.911987%)",
    offset: 0.476563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.198425%, 6.098938%, 12.684631%)",
    offset: 0.480469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.998535%, 5.899048%, 12.471008%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.798645%, 5.899048%, 12.335205%)",
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.598755%, 5.899048%, 12.199402%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.598755%, 5.699158%, 11.999512%)",
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.598755%, 5.499268%, 11.799622%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.398865%, 5.499268%, 11.799622%)",
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.198975%, 5.499268%, 11.799622%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.198975%, 5.499268%, 11.599731%)",
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.198975%, 5.499268%, 11.399841%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.999084%, 5.299377%, 11.198425%)",
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.799194%, 5.099487%, 10.998535%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.599304%, 5.099487%, 10.798645%)",
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.399414%, 5.099487%, 10.598755%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.399414%, 5.099487%, 10.595703%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.205627%, 4.905701%, 10.395813%)",
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.011841%, 4.711914%, 10.198975%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.005737%, 4.705811%, 10.014343%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.799744%, 4.699707%, 9.814453%)",
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.599854%, 4.699707%, 9.799194%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.583069%, 4.499817%, 9.584045%)",
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.56781%, 4.299927%, 9.368896%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.383179%, 4.299927%, 9.184265%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.198547%, 4.299927%, 8.802795%)",
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.198547%, 4.299927%, 8.605957%)",
    offset: 0.585937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.998657%, 4.112244%, 8.602905%)",
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.798767%, 3.924561%, 8.599854%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.798767%, 3.910828%, 8.398438%)",
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.798767%, 3.898621%, 8.198547%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.649231%, 3.898621%, 7.998657%)",
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.499695%, 3.898621%, 7.798767%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.49054%, 3.889465%, 7.791138%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.290649%, 3.689575%, 7.641602%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.099915%, 3.49884%, 7.499695%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.898499%, 3.49884%, 7.299805%)",
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.698608%, 3.49884%, 7.099915%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.677246%, 3.29895%, 6.898499%)",
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.655884%, 3.09906%, 6.698608%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.477356%, 3.09906%, 6.686401%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.298828%, 3.09906%, 6.486511%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.105042%, 2.905273%, 6.105042%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.731201%, 2.705383%, 5.731201%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.523682%, 2.687073%, 5.508423%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.493164%, 2.537537%, 5.284119%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.293274%, 2.398682%, 5.099487%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.099487%, 2.398682%, 4.899597%)",
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.099487%, 2.398682%, 4.699707%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.920959%, 2.398682%, 4.699707%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.721069%, 2.198792%, 4.499817%)",
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.699707%, 1.998901%, 4.299927%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.699707%, 1.998901%, 4.290771%)",
    offset: 0.742187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.499817%, 1.998901%, 4.089355%)",
    offset: 0.746094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.299927%, 1.998901%, 3.898621%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.299927%, 1.998901%, 3.898621%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.299927%, 1.817322%, 3.69873%)",
    offset: 0.761719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.299927%, 1.637268%, 3.49884%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.098511%, 1.617432%, 3.477478%)",
    offset: 0.769531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.898621%, 1.599121%, 3.456116%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.898621%, 1.599121%, 3.277588%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.898621%, 1.599121%, 3.09906%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.70636%, 1.599121%, 2.906799%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.50647%, 1.411438%, 2.706909%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.495789%, 1.211548%, 2.548218%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.297424%, 1.199341%, 2.398682%)",
    offset: 0.835937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.100586%, 1.199341%, 2.398682%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.09906%, 1.199341%, 2.2995%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.09906%, 1.199341%, 2.099609%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.09906%, 1.098633%, 1.998901%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.09906%, 0.898743%, 1.998901%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 110 22.410156 L 162 22.410156 L 162 195.625 L 110 195.625 Z M 110 22.410156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 110.847656 22.523438 L 161.238281 22.523438 L 161.238281 195.542969 L 110.847656 195.542969 Z M 110.847656 22.523438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 161.238281 182.726562 L 161.238281 24.105469 C 161.238281 23.566406 161.199219 23.042969 161.148438 22.523438 L 110.933594 22.523438 C 110.882812 23.042969 110.847656 23.566406 110.847656 24.105469 L 110.847656 182.726562 C 110.847656 189.804688 115.472656 195.542969 121.183594 195.542969 L 150.898438 195.542969 C 156.605469 195.542969 161.238281 189.804688 161.238281 182.726562 Z M 160.050781 182.726562 C 160.050781 189.136719 155.945312 194.355469 150.898438 194.355469 L 121.183594 194.355469 C 116.136719 194.355469 112.03125 189.136719 112.03125 182.726562 L 112.03125 24.105469 C 112.03125 23.980469 112.039062 23.84375 112.042969 23.710938 L 160.042969 23.710938 C 160.046875 23.84375 160.050781 23.980469 160.050781 24.105469 L 160.050781 182.726562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 161.238281 182.726562 L 161.238281 24.105469 C 161.238281 23.566406 161.199219 23.042969 161.148438 22.523438 L 110.933594 22.523438 C 110.882812 23.042969 110.847656 23.566406 110.847656 24.105469 L 110.847656 182.726562 C 110.847656 189.804688 115.472656 195.542969 121.183594 195.542969 L 150.898438 195.542969 C 156.605469 195.542969 161.238281 189.804688 161.238281 182.726562 Z M 160.050781 182.726562 C 160.050781 189.136719 155.945312 194.355469 150.898438 194.355469 L 121.183594 194.355469 C 116.136719 194.355469 112.03125 189.136719 112.03125 182.726562 L 112.03125 24.105469 C 112.03125 23.980469 112.039062 23.84375 112.042969 23.710938 L 160.042969 23.710938 C 160.046875 23.84375 160.050781 23.980469 160.050781 24.105469 L 160.050781 182.726562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 4.74786e-9,
    gradientTransform: "matrix(0.000000000000010594, 173.01823, -173.01823, 0.000000000000010594, 136.041779, 22.52483)",
    y1: 0,
    x2: 0.999992,
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    id: "id15"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.498535%, 12.89978%, 27.49939%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.498535%, 12.89978%, 27.49939%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.498535%, 12.89978%, 27.49939%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.298645%, 12.69989%, 27.2995%)",
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.098755%, 12.5%, 27.099609%)",
    offset: 0.148437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.086548%, 12.5%, 26.899719%)",
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.074341%, 12.5%, 26.699829%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.883606%, 12.348938%, 26.498413%)",
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.694397%, 12.199402%, 26.298523%)",
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.546387%, 12.199402%, 26.104736%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.198486%, 12.199402%, 25.721741%)",
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.998596%, 12.199402%, 25.531006%)",
    offset: 0.179687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.82312%, 11.999512%, 25.340271%)",
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.64917%, 11.799622%, 25.149536%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.42334%, 11.782837%, 24.923706%)",
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 11.767578%, 24.699402%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.192932%, 11.582947%, 24.499512%)",
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.186829%, 11.399841%, 24.299622%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.993042%, 11.399841%, 24.299622%)",
    offset: 0.210937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.599365%, 11.212158%, 24.099731%)",
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.399475%, 11.024475%, 23.899841%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.220947%, 11.010742%, 23.698425%)",
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.042419%, 10.998535%, 23.498535%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.821167%, 10.980225%, 23.280334%)",
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.599915%, 10.961914%, 23.062134%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.589233%, 10.780334%, 22.872925%)",
    offset: 0.242187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.389343%, 10.598755%, 22.541809%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.998718%, 10.40802%, 22.209167%)",
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.798828%, 10.218811%, 22.018433%)",
    offset: 0.257813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.617249%, 10.20813%, 21.827698%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.217468%, 10.177612%, 21.417236%)",
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.999268%, 10.15625%, 21.199036%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.987061%, 9.977722%, 20.999146%)",
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.974854%, 9.799194%, 20.799255%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.78717%, 9.799194%, 20.599365%)",
    offset: 0.285156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.599487%, 9.799194%, 20.399475%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.453003%, 9.605408%, 20.399475%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.118835%, 9.405518%, 20.199585%)",
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.931152%, 9.399414%, 19.999695%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.914368%, 9.399414%, 19.799805%)",
    offset: 0.308594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.899109%, 9.399414%, 19.599915%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.699219%, 9.199524%, 19.398499%)",
    offset: 0.316406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.499329%, 8.999634%, 19.198608%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.299438%, 8.999634%, 18.998718%)",
    offset: 0.324219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.099548%, 8.999634%, 18.798828%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.90271%, 8.802795%, 18.60199%)",
    offset: 0.332031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.705872%, 8.605957%, 18.405151%)",
    offset: 0.335937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.70282%, 8.602905%, 18.214417%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.499878%, 8.599854%, 18.011475%)",
    offset: 0.347656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.299988%, 8.599854%, 17.999268%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.098572%, 8.398438%, 17.785645%)",
    offset: 0.355469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.898682%, 8.198547%, 17.572021%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.889526%, 8.198547%, 17.425537%)",
    offset: 0.367187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.689636%, 7.998657%, 17.089844%)",
    offset: 0.371094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.498901%, 7.800293%, 16.899109%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.308167%, 7.798767%, 16.708374%)",
    offset: 0.382813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.108276%, 7.798767%, 16.326904%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.899231%, 7.649231%, 16.096497%)",
    offset: 0.394531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.699341%, 7.499695%, 16.055298%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.499451%, 7.499695%, 15.864563%)",
    offset: 0.402344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.299561%, 7.499695%, 15.673828%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.296509%, 7.299805%, 15.486145%)",
    offset: 0.410156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.293457%, 7.099915%, 15.299988%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.096619%, 7.099915%, 15.106201%)",
    offset: 0.417969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.89978%, 7.099915%, 14.912415%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.715149%, 7.099915%, 14.72168%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.515259%, 6.924438%, 14.51416%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.348938%, 6.723022%, 14.283752%)",
    offset: 0.441406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.199402%, 6.698608%, 14.068604%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.999512%, 6.692505%, 13.883972%)",
    offset: 0.449219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.799622%, 6.686401%, 13.699341%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.799622%, 6.492615%, 13.502502%)",
    offset: 0.457031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.799622%, 6.298828%, 13.305664%)",
    offset: 0.460937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.599731%, 6.298828%, 13.114929%)",
    offset: 0.464844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.399841%, 6.298828%, 12.924194%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.399841%, 6.298828%, 12.911987%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.198425%, 6.098938%, 12.684631%)",
    offset: 0.480469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.998535%, 5.899048%, 12.471008%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.798645%, 5.899048%, 12.335205%)",
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.598755%, 5.899048%, 12.199402%)",
    offset: 0.492187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.598755%, 5.699158%, 11.999512%)",
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.598755%, 5.499268%, 11.799622%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.398865%, 5.499268%, 11.799622%)",
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.198975%, 5.499268%, 11.799622%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.198975%, 5.499268%, 11.599731%)",
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.198975%, 5.499268%, 11.399841%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.999084%, 5.299377%, 11.198425%)",
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.799194%, 5.099487%, 10.998535%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.599304%, 5.099487%, 10.798645%)",
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.399414%, 5.099487%, 10.598755%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.399414%, 5.099487%, 10.595703%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.205627%, 4.905701%, 10.395813%)",
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.011841%, 4.711914%, 10.198975%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.005737%, 4.705811%, 10.014343%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.799744%, 4.699707%, 9.814453%)",
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.599854%, 4.699707%, 9.799194%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.583069%, 4.499817%, 9.584045%)",
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.56781%, 4.299927%, 9.368896%)",
    offset: 0.570313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.383179%, 4.299927%, 9.184265%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.198547%, 4.299927%, 8.802795%)",
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.198547%, 4.299927%, 8.605957%)",
    offset: 0.585937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.998657%, 4.112244%, 8.602905%)",
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.798767%, 3.924561%, 8.599854%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.798767%, 3.910828%, 8.398438%)",
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.798767%, 3.898621%, 8.198547%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.649231%, 3.898621%, 7.998657%)",
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.499695%, 3.898621%, 7.798767%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.49054%, 3.889465%, 7.791138%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.290649%, 3.689575%, 7.641602%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.099915%, 3.49884%, 7.499695%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.898499%, 3.49884%, 7.299805%)",
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.698608%, 3.49884%, 7.099915%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.677246%, 3.29895%, 6.898499%)",
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.655884%, 3.09906%, 6.698608%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.477356%, 3.09906%, 6.686401%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.298828%, 3.09906%, 6.486511%)",
    offset: 0.664063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.105042%, 2.905273%, 6.105042%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.731201%, 2.705383%, 5.731201%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.523682%, 2.687073%, 5.508423%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.493164%, 2.537537%, 5.284119%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.293274%, 2.398682%, 5.099487%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.099487%, 2.398682%, 4.899597%)",
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.099487%, 2.398682%, 4.699707%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.920959%, 2.398682%, 4.699707%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.721069%, 2.198792%, 4.499817%)",
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.699707%, 1.998901%, 4.299927%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.699707%, 1.998901%, 4.290771%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.499817%, 1.998901%, 4.089355%)",
    offset: 0.746094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.299927%, 1.998901%, 3.898621%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.299927%, 1.998901%, 3.898621%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.299927%, 1.817322%, 3.69873%)",
    offset: 0.761719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.299927%, 1.637268%, 3.49884%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.098511%, 1.617432%, 3.477478%)",
    offset: 0.769531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.898621%, 1.599121%, 3.456116%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.898621%, 1.599121%, 3.277588%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.898621%, 1.599121%, 3.09906%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.70636%, 1.599121%, 2.906799%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.50647%, 1.411438%, 2.706909%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.495789%, 1.211548%, 2.548218%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.297424%, 1.199341%, 2.398682%)",
    offset: 0.835937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.100586%, 1.199341%, 2.398682%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.09906%, 1.199341%, 2.2995%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.09906%, 1.199341%, 2.099609%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.09906%, 1.098633%, 1.998901%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.09906%, 0.898743%, 1.998901%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 161 22.410156 L 212 22.410156 L 212 195.625 L 161 195.625 Z M 161 22.410156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 161.238281 22.523438 L 211.621094 22.523438 L 211.621094 195.542969 L 161.238281 195.542969 Z M 161.238281 22.523438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 211.621094 182.726562 L 211.621094 24.105469 C 211.621094 23.566406 211.589844 23.042969 211.539062 22.523438 L 161.324219 22.523438 C 161.273438 23.042969 161.238281 23.566406 161.238281 24.105469 L 161.238281 182.726562 C 161.238281 189.804688 165.863281 195.542969 171.570312 195.542969 L 201.285156 195.542969 C 206.996094 195.542969 211.621094 189.804688 211.621094 182.726562 Z M 210.4375 182.726562 C 210.4375 189.136719 206.332031 194.355469 201.285156 194.355469 L 171.570312 194.355469 C 166.527344 194.355469 162.421875 189.136719 162.421875 182.726562 L 162.421875 24.105469 C 162.421875 23.980469 162.421875 23.84375 162.425781 23.710938 L 210.433594 23.710938 C 210.4375 23.84375 210.4375 23.980469 210.4375 24.105469 L 210.4375 182.726562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 211.621094 182.726562 L 211.621094 24.105469 C 211.621094 23.566406 211.589844 23.042969 211.539062 22.523438 L 161.324219 22.523438 C 161.273438 23.042969 161.238281 23.566406 161.238281 24.105469 L 161.238281 182.726562 C 161.238281 189.804688 165.863281 195.542969 171.570312 195.542969 L 201.285156 195.542969 C 206.996094 195.542969 211.621094 189.804688 211.621094 182.726562 Z M 210.4375 182.726562 C 210.4375 189.136719 206.332031 194.355469 201.285156 194.355469 L 171.570312 194.355469 C 166.527344 194.355469 162.421875 189.136719 162.421875 182.726562 L 162.421875 24.105469 C 162.421875 23.980469 162.421875 23.84375 162.425781 23.710938 L 210.433594 23.710938 C 210.4375 23.84375 210.4375 23.980469 210.4375 24.105469 L 210.4375 182.726562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 4.74786e-9,
    gradientTransform: "matrix(0.000000000000010594, 173.01823, -173.01823, 0.000000000000010594, 186.43066, 22.52483)",
    y1: 0,
    x2: 0.999992,
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    id: "id20"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.498535%, 12.89978%, 27.49939%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.498535%, 12.89978%, 27.49939%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.498535%, 12.89978%, 27.49939%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.298645%, 12.69989%, 27.2995%)",
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.098755%, 12.5%, 27.099609%)",
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.086548%, 12.5%, 26.899719%)",
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.074341%, 12.5%, 26.699829%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.883606%, 12.348938%, 26.498413%)",
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.694397%, 12.199402%, 26.298523%)",
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.546387%, 12.199402%, 26.104736%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.198486%, 12.199402%, 25.721741%)",
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.998596%, 12.199402%, 25.531006%)",
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.82312%, 11.999512%, 25.340271%)",
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.64917%, 11.799622%, 25.149536%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.42334%, 11.782837%, 24.923706%)",
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 11.767578%, 24.699402%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.192932%, 11.582947%, 24.499512%)",
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.186829%, 11.399841%, 24.299622%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.993042%, 11.399841%, 24.299622%)",
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.599365%, 11.212158%, 24.099731%)",
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.399475%, 11.024475%, 23.899841%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.220947%, 11.010742%, 23.698425%)",
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.042419%, 10.998535%, 23.498535%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.821167%, 10.980225%, 23.280334%)",
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.599915%, 10.961914%, 23.062134%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.589233%, 10.780334%, 22.872925%)",
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.389343%, 10.598755%, 22.541809%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.998718%, 10.40802%, 22.209167%)",
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.798828%, 10.218811%, 22.018433%)",
    offset: 0.257813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.617249%, 10.20813%, 21.827698%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.217468%, 10.177612%, 21.417236%)",
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.999268%, 10.15625%, 21.199036%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.987061%, 9.977722%, 20.999146%)",
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.974854%, 9.799194%, 20.799255%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.78717%, 9.799194%, 20.599365%)",
    offset: 0.285156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.599487%, 9.799194%, 20.399475%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.453003%, 9.605408%, 20.399475%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.118835%, 9.405518%, 20.199585%)",
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.931152%, 9.399414%, 19.999695%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.914368%, 9.399414%, 19.799805%)",
    offset: 0.308594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.899109%, 9.399414%, 19.599915%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.699219%, 9.199524%, 19.398499%)",
    offset: 0.316406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.499329%, 8.999634%, 19.198608%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.299438%, 8.999634%, 18.998718%)",
    offset: 0.324219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.099548%, 8.999634%, 18.798828%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.90271%, 8.802795%, 18.60199%)",
    offset: 0.332031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.705872%, 8.605957%, 18.405151%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.70282%, 8.602905%, 18.214417%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.499878%, 8.599854%, 18.011475%)",
    offset: 0.347656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.299988%, 8.599854%, 17.999268%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.098572%, 8.398438%, 17.785645%)",
    offset: 0.355469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.898682%, 8.198547%, 17.572021%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.889526%, 8.198547%, 17.425537%)",
    offset: 0.367187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.689636%, 7.998657%, 17.089844%)",
    offset: 0.371094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.498901%, 7.800293%, 16.899109%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.308167%, 7.798767%, 16.708374%)",
    offset: 0.382813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.108276%, 7.798767%, 16.326904%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.899231%, 7.649231%, 16.096497%)",
    offset: 0.394531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.699341%, 7.499695%, 16.055298%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.499451%, 7.499695%, 15.864563%)",
    offset: 0.402344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.299561%, 7.499695%, 15.673828%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.296509%, 7.299805%, 15.486145%)",
    offset: 0.410156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.293457%, 7.099915%, 15.299988%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.096619%, 7.099915%, 15.106201%)",
    offset: 0.417969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.89978%, 7.099915%, 14.912415%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.715149%, 7.099915%, 14.72168%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.515259%, 6.924438%, 14.51416%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.348938%, 6.723022%, 14.283752%)",
    offset: 0.441406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.199402%, 6.698608%, 14.068604%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.999512%, 6.692505%, 13.883972%)",
    offset: 0.449219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.799622%, 6.686401%, 13.699341%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.799622%, 6.492615%, 13.502502%)",
    offset: 0.457031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.799622%, 6.298828%, 13.305664%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.599731%, 6.298828%, 13.114929%)",
    offset: 0.464844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.399841%, 6.298828%, 12.924194%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.399841%, 6.298828%, 12.911987%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.198425%, 6.098938%, 12.684631%)",
    offset: 0.480469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.998535%, 5.899048%, 12.471008%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.798645%, 5.899048%, 12.335205%)",
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.598755%, 5.899048%, 12.199402%)",
    offset: 0.492187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.598755%, 5.699158%, 11.999512%)",
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.598755%, 5.499268%, 11.799622%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.398865%, 5.499268%, 11.799622%)",
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.198975%, 5.499268%, 11.799622%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.198975%, 5.499268%, 11.599731%)",
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.198975%, 5.499268%, 11.399841%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.999084%, 5.299377%, 11.198425%)",
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.799194%, 5.099487%, 10.998535%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.599304%, 5.099487%, 10.798645%)",
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.399414%, 5.099487%, 10.598755%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.399414%, 5.099487%, 10.595703%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.205627%, 4.905701%, 10.395813%)",
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.011841%, 4.711914%, 10.198975%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.005737%, 4.705811%, 10.014343%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.799744%, 4.699707%, 9.814453%)",
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.599854%, 4.699707%, 9.799194%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.583069%, 4.499817%, 9.584045%)",
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.56781%, 4.299927%, 9.368896%)",
    offset: 0.570313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.383179%, 4.299927%, 9.184265%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.198547%, 4.299927%, 8.802795%)",
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.198547%, 4.299927%, 8.605957%)",
    offset: 0.585937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.998657%, 4.112244%, 8.602905%)",
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.798767%, 3.924561%, 8.599854%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.798767%, 3.910828%, 8.398438%)",
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.798767%, 3.898621%, 8.198547%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.649231%, 3.898621%, 7.998657%)",
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.499695%, 3.898621%, 7.798767%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.49054%, 3.889465%, 7.791138%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.290649%, 3.689575%, 7.641602%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.099915%, 3.49884%, 7.499695%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.898499%, 3.49884%, 7.299805%)",
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.698608%, 3.49884%, 7.099915%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.677246%, 3.29895%, 6.898499%)",
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.655884%, 3.09906%, 6.698608%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.477356%, 3.09906%, 6.686401%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.298828%, 3.09906%, 6.486511%)",
    offset: 0.664063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.105042%, 2.905273%, 6.105042%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.731201%, 2.705383%, 5.731201%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.523682%, 2.687073%, 5.508423%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.493164%, 2.537537%, 5.284119%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.293274%, 2.398682%, 5.099487%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.099487%, 2.398682%, 4.899597%)",
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.099487%, 2.398682%, 4.699707%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.920959%, 2.398682%, 4.699707%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.721069%, 2.198792%, 4.499817%)",
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.699707%, 1.998901%, 4.299927%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.699707%, 1.998901%, 4.290771%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.499817%, 1.998901%, 4.089355%)",
    offset: 0.746094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.299927%, 1.998901%, 3.898621%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.299927%, 1.998901%, 3.898621%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.299927%, 1.817322%, 3.69873%)",
    offset: 0.761719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.299927%, 1.637268%, 3.49884%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.098511%, 1.617432%, 3.477478%)",
    offset: 0.769531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.898621%, 1.599121%, 3.456116%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.898621%, 1.599121%, 3.277588%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.898621%, 1.599121%, 3.09906%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.70636%, 1.599121%, 2.906799%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.50647%, 1.411438%, 2.706909%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.495789%, 1.211548%, 2.548218%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.297424%, 1.199341%, 2.398682%)",
    offset: 0.835937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.100586%, 1.199341%, 2.398682%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.09906%, 1.199341%, 2.2995%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.09906%, 1.199341%, 2.099609%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.09906%, 1.098633%, 1.998901%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.09906%, 0.898743%, 1.998901%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 211 22.410156 L 263 22.410156 L 263 195.625 L 211 195.625 Z M 211 22.410156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 211.621094 22.523438 L 262.011719 22.523438 L 262.011719 195.542969 L 211.621094 195.542969 Z M 211.621094 22.523438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 262.011719 182.726562 L 262.011719 24.105469 C 262.011719 23.566406 261.976562 23.042969 261.925781 22.523438 L 211.710938 22.523438 C 211.660156 23.042969 211.621094 23.566406 211.621094 24.105469 L 211.621094 182.726562 C 211.621094 189.804688 216.253906 195.542969 221.960938 195.542969 L 251.675781 195.542969 C 257.386719 195.542969 262.011719 189.804688 262.011719 182.726562 Z M 260.828125 182.726562 C 260.828125 189.136719 256.722656 194.355469 251.675781 194.355469 L 221.960938 194.355469 C 216.917969 194.355469 212.808594 189.136719 212.808594 182.726562 L 212.808594 24.105469 C 212.808594 23.980469 212.8125 23.84375 212.816406 23.710938 L 260.816406 23.710938 C 260.824219 23.84375 260.828125 23.980469 260.828125 24.105469 L 260.828125 182.726562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 262.011719 182.726562 L 262.011719 24.105469 C 262.011719 23.566406 261.976562 23.042969 261.925781 22.523438 L 211.710938 22.523438 C 211.660156 23.042969 211.621094 23.566406 211.621094 24.105469 L 211.621094 182.726562 C 211.621094 189.804688 216.253906 195.542969 221.960938 195.542969 L 251.675781 195.542969 C 257.386719 195.542969 262.011719 189.804688 262.011719 182.726562 Z M 260.828125 182.726562 C 260.828125 189.136719 256.722656 194.355469 251.675781 194.355469 L 221.960938 194.355469 C 216.917969 194.355469 212.808594 189.136719 212.808594 182.726562 L 212.808594 24.105469 C 212.808594 23.980469 212.8125 23.84375 212.816406 23.710938 L 260.816406 23.710938 C 260.824219 23.84375 260.828125 23.980469 260.828125 24.105469 L 260.828125 182.726562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 4.74786e-9,
    gradientTransform: "matrix(0.000000000000010594, 173.01823, -173.01823, 0.000000000000010594, 236.81839, 22.52483)",
    y1: 0,
    x2: 0.999992,
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    id: "id25"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.498535%, 12.89978%, 27.49939%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.498535%, 12.89978%, 27.49939%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.498535%, 12.89978%, 27.49939%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.298645%, 12.69989%, 27.2995%)",
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.098755%, 12.5%, 27.099609%)",
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.086548%, 12.5%, 26.899719%)",
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.074341%, 12.5%, 26.699829%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.883606%, 12.348938%, 26.498413%)",
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.694397%, 12.199402%, 26.298523%)",
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.546387%, 12.199402%, 26.104736%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.198486%, 12.199402%, 25.721741%)",
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.998596%, 12.199402%, 25.531006%)",
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.82312%, 11.999512%, 25.340271%)",
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.64917%, 11.799622%, 25.149536%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.42334%, 11.782837%, 24.923706%)",
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 11.767578%, 24.699402%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.192932%, 11.582947%, 24.499512%)",
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.186829%, 11.399841%, 24.299622%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.993042%, 11.399841%, 24.299622%)",
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.599365%, 11.212158%, 24.099731%)",
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.399475%, 11.024475%, 23.899841%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.220947%, 11.010742%, 23.698425%)",
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.042419%, 10.998535%, 23.498535%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.821167%, 10.980225%, 23.280334%)",
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.599915%, 10.961914%, 23.062134%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.589233%, 10.780334%, 22.872925%)",
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.389343%, 10.598755%, 22.541809%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.998718%, 10.40802%, 22.209167%)",
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.798828%, 10.218811%, 22.018433%)",
    offset: 0.257813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.617249%, 10.20813%, 21.827698%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.217468%, 10.177612%, 21.417236%)",
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.999268%, 10.15625%, 21.199036%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.987061%, 9.977722%, 20.999146%)",
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.974854%, 9.799194%, 20.799255%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.78717%, 9.799194%, 20.599365%)",
    offset: 0.285156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.599487%, 9.799194%, 20.399475%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.453003%, 9.605408%, 20.399475%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.118835%, 9.405518%, 20.199585%)",
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.931152%, 9.399414%, 19.999695%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.914368%, 9.399414%, 19.799805%)",
    offset: 0.308594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.899109%, 9.399414%, 19.599915%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.699219%, 9.199524%, 19.398499%)",
    offset: 0.316406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.499329%, 8.999634%, 19.198608%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.299438%, 8.999634%, 18.998718%)",
    offset: 0.324219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.099548%, 8.999634%, 18.798828%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.90271%, 8.802795%, 18.60199%)",
    offset: 0.332031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.705872%, 8.605957%, 18.405151%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.70282%, 8.602905%, 18.214417%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.499878%, 8.599854%, 18.011475%)",
    offset: 0.347656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.299988%, 8.599854%, 17.999268%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.098572%, 8.398438%, 17.785645%)",
    offset: 0.355469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.898682%, 8.198547%, 17.572021%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.889526%, 8.198547%, 17.425537%)",
    offset: 0.367187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.689636%, 7.998657%, 17.089844%)",
    offset: 0.371094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.498901%, 7.800293%, 16.899109%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.308167%, 7.798767%, 16.708374%)",
    offset: 0.382813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.108276%, 7.798767%, 16.326904%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.899231%, 7.649231%, 16.096497%)",
    offset: 0.394531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.699341%, 7.499695%, 16.055298%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.499451%, 7.499695%, 15.864563%)",
    offset: 0.402344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.299561%, 7.499695%, 15.673828%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.296509%, 7.299805%, 15.486145%)",
    offset: 0.410156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.293457%, 7.099915%, 15.299988%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.096619%, 7.099915%, 15.106201%)",
    offset: 0.417969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.89978%, 7.099915%, 14.912415%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.715149%, 7.099915%, 14.72168%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.515259%, 6.924438%, 14.51416%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.348938%, 6.723022%, 14.283752%)",
    offset: 0.441406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.199402%, 6.698608%, 14.068604%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.999512%, 6.692505%, 13.883972%)",
    offset: 0.449219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.799622%, 6.686401%, 13.699341%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.799622%, 6.492615%, 13.502502%)",
    offset: 0.457031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.799622%, 6.298828%, 13.305664%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.599731%, 6.298828%, 13.114929%)",
    offset: 0.464844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.399841%, 6.298828%, 12.924194%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.399841%, 6.298828%, 12.911987%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.198425%, 6.098938%, 12.684631%)",
    offset: 0.480469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.998535%, 5.899048%, 12.471008%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.798645%, 5.899048%, 12.335205%)",
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.598755%, 5.899048%, 12.199402%)",
    offset: 0.492187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.598755%, 5.699158%, 11.999512%)",
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.598755%, 5.499268%, 11.799622%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.398865%, 5.499268%, 11.799622%)",
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.198975%, 5.499268%, 11.799622%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.198975%, 5.499268%, 11.599731%)",
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.198975%, 5.499268%, 11.399841%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.999084%, 5.299377%, 11.198425%)",
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.799194%, 5.099487%, 10.998535%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.599304%, 5.099487%, 10.798645%)",
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.399414%, 5.099487%, 10.598755%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.399414%, 5.099487%, 10.595703%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.205627%, 4.905701%, 10.395813%)",
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.011841%, 4.711914%, 10.198975%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.005737%, 4.705811%, 10.014343%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.799744%, 4.699707%, 9.814453%)",
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.599854%, 4.699707%, 9.799194%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.583069%, 4.499817%, 9.584045%)",
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.56781%, 4.299927%, 9.368896%)",
    offset: 0.570313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.383179%, 4.299927%, 9.184265%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.198547%, 4.299927%, 8.802795%)",
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.198547%, 4.299927%, 8.605957%)",
    offset: 0.585937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.998657%, 4.112244%, 8.602905%)",
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.798767%, 3.924561%, 8.599854%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.798767%, 3.910828%, 8.398438%)",
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.798767%, 3.898621%, 8.198547%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.649231%, 3.898621%, 7.998657%)",
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.499695%, 3.898621%, 7.798767%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.49054%, 3.889465%, 7.791138%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.290649%, 3.689575%, 7.641602%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.099915%, 3.49884%, 7.499695%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.898499%, 3.49884%, 7.299805%)",
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.698608%, 3.49884%, 7.099915%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.677246%, 3.29895%, 6.898499%)",
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.655884%, 3.09906%, 6.698608%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.477356%, 3.09906%, 6.686401%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.298828%, 3.09906%, 6.486511%)",
    offset: 0.664063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.105042%, 2.905273%, 6.105042%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.731201%, 2.705383%, 5.731201%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.523682%, 2.687073%, 5.508423%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.493164%, 2.537537%, 5.284119%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.293274%, 2.398682%, 5.099487%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.099487%, 2.398682%, 4.899597%)",
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.099487%, 2.398682%, 4.699707%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.920959%, 2.398682%, 4.699707%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.721069%, 2.198792%, 4.499817%)",
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.699707%, 1.998901%, 4.299927%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.699707%, 1.998901%, 4.290771%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.499817%, 1.998901%, 4.089355%)",
    offset: 0.746094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.299927%, 1.998901%, 3.898621%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.299927%, 1.998901%, 3.898621%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.299927%, 1.817322%, 3.69873%)",
    offset: 0.761719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.299927%, 1.637268%, 3.49884%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.098511%, 1.617432%, 3.477478%)",
    offset: 0.769531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.898621%, 1.599121%, 3.456116%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.898621%, 1.599121%, 3.277588%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.898621%, 1.599121%, 3.09906%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.70636%, 1.599121%, 2.906799%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.50647%, 1.411438%, 2.706909%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.495789%, 1.211548%, 2.548218%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.297424%, 1.199341%, 2.398682%)",
    offset: 0.835937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.100586%, 1.199341%, 2.398682%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.09906%, 1.199341%, 2.2995%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.09906%, 1.199341%, 2.099609%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.09906%, 1.098633%, 1.998901%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.09906%, 0.898743%, 1.998901%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 262 22.410156 L 313 22.410156 L 313 195.625 L 262 195.625 Z M 262 22.410156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 262.011719 22.523438 L 312.402344 22.523438 L 312.402344 195.542969 L 262.011719 195.542969 Z M 262.011719 22.523438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 312.402344 182.726562 L 312.402344 24.105469 C 312.402344 23.566406 312.367188 23.042969 312.316406 22.523438 L 262.101562 22.523438 C 262.050781 23.042969 262.011719 23.566406 262.011719 24.105469 L 262.011719 182.726562 C 262.011719 189.804688 266.640625 195.542969 272.351562 195.542969 L 302.066406 195.542969 C 307.777344 195.542969 312.402344 189.804688 312.402344 182.726562 Z M 311.21875 182.726562 C 311.21875 189.136719 307.109375 194.355469 302.066406 194.355469 L 272.351562 194.355469 C 267.300781 194.355469 263.199219 189.136719 263.199219 182.726562 L 263.199219 24.105469 C 263.199219 23.980469 263.199219 23.84375 263.203125 23.710938 L 311.207031 23.710938 C 311.210938 23.84375 311.21875 23.980469 311.21875 24.105469 L 311.21875 182.726562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 312.402344 182.726562 L 312.402344 24.105469 C 312.402344 23.566406 312.367188 23.042969 312.316406 22.523438 L 262.101562 22.523438 C 262.050781 23.042969 262.011719 23.566406 262.011719 24.105469 L 262.011719 182.726562 C 262.011719 189.804688 266.640625 195.542969 272.351562 195.542969 L 302.066406 195.542969 C 307.777344 195.542969 312.402344 189.804688 312.402344 182.726562 Z M 311.21875 182.726562 C 311.21875 189.136719 307.109375 194.355469 302.066406 194.355469 L 272.351562 194.355469 C 267.300781 194.355469 263.199219 189.136719 263.199219 182.726562 L 263.199219 24.105469 C 263.199219 23.980469 263.199219 23.84375 263.203125 23.710938 L 311.207031 23.710938 C 311.210938 23.84375 311.21875 23.980469 311.21875 24.105469 L 311.21875 182.726562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 4.74786e-9,
    gradientTransform: "matrix(0.000000000000010594, 173.01823, -173.01823, 0.000000000000010594, 287.20728, 22.52483)",
    y1: 0,
    x2: 0.999992,
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    id: "id30"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.498535%, 12.89978%, 27.49939%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.498535%, 12.89978%, 27.49939%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.498535%, 12.89978%, 27.49939%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.298645%, 12.69989%, 27.2995%)",
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.098755%, 12.5%, 27.099609%)",
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.086548%, 12.5%, 26.899719%)",
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.074341%, 12.5%, 26.699829%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.883606%, 12.348938%, 26.498413%)",
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.694397%, 12.199402%, 26.298523%)",
    offset: 0.164063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.546387%, 12.199402%, 26.104736%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.198486%, 12.199402%, 25.721741%)",
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.998596%, 12.199402%, 25.531006%)",
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.82312%, 11.999512%, 25.340271%)",
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.64917%, 11.799622%, 25.149536%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.42334%, 11.782837%, 24.923706%)",
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 11.767578%, 24.699402%)",
    offset: 0.195313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.192932%, 11.582947%, 24.499512%)",
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.186829%, 11.399841%, 24.299622%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.993042%, 11.399841%, 24.299622%)",
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.599365%, 11.212158%, 24.099731%)",
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.399475%, 11.024475%, 23.899841%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.220947%, 11.010742%, 23.698425%)",
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.042419%, 10.998535%, 23.498535%)",
    offset: 0.226563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.821167%, 10.980225%, 23.280334%)",
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.599915%, 10.961914%, 23.062134%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.589233%, 10.780334%, 22.872925%)",
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.389343%, 10.598755%, 22.541809%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.998718%, 10.40802%, 22.209167%)",
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.798828%, 10.218811%, 22.018433%)",
    offset: 0.257813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.617249%, 10.20813%, 21.827698%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.217468%, 10.177612%, 21.417236%)",
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.999268%, 10.15625%, 21.199036%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.987061%, 9.977722%, 20.999146%)",
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.974854%, 9.799194%, 20.799255%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.78717%, 9.799194%, 20.599365%)",
    offset: 0.285156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.599487%, 9.799194%, 20.399475%)",
    offset: 0.289063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.453003%, 9.605408%, 20.399475%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.118835%, 9.405518%, 20.199585%)",
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.931152%, 9.399414%, 19.999695%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.914368%, 9.399414%, 19.799805%)",
    offset: 0.308594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.899109%, 9.399414%, 19.599915%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.699219%, 9.199524%, 19.398499%)",
    offset: 0.316406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.499329%, 8.999634%, 19.198608%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.299438%, 8.999634%, 18.998718%)",
    offset: 0.324219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.099548%, 8.999634%, 18.798828%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.90271%, 8.802795%, 18.60199%)",
    offset: 0.332031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.705872%, 8.605957%, 18.405151%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.70282%, 8.602905%, 18.214417%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.499878%, 8.599854%, 18.011475%)",
    offset: 0.347656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.299988%, 8.599854%, 17.999268%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.098572%, 8.398438%, 17.785645%)",
    offset: 0.355469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.898682%, 8.198547%, 17.572021%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.889526%, 8.198547%, 17.425537%)",
    offset: 0.367187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.689636%, 7.998657%, 17.089844%)",
    offset: 0.371094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.498901%, 7.800293%, 16.899109%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.308167%, 7.798767%, 16.708374%)",
    offset: 0.382813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.108276%, 7.798767%, 16.326904%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.899231%, 7.649231%, 16.096497%)",
    offset: 0.394531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.699341%, 7.499695%, 16.055298%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.499451%, 7.499695%, 15.864563%)",
    offset: 0.402344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.299561%, 7.499695%, 15.673828%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.296509%, 7.299805%, 15.486145%)",
    offset: 0.410156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.293457%, 7.099915%, 15.299988%)",
    offset: 0.414063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.096619%, 7.099915%, 15.106201%)",
    offset: 0.417969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.89978%, 7.099915%, 14.912415%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.715149%, 7.099915%, 14.72168%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.515259%, 6.924438%, 14.51416%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.348938%, 6.723022%, 14.283752%)",
    offset: 0.441406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.199402%, 6.698608%, 14.068604%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.999512%, 6.692505%, 13.883972%)",
    offset: 0.449219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.799622%, 6.686401%, 13.699341%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.799622%, 6.492615%, 13.502502%)",
    offset: 0.457031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.799622%, 6.298828%, 13.305664%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.599731%, 6.298828%, 13.114929%)",
    offset: 0.464844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.399841%, 6.298828%, 12.924194%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.399841%, 6.298828%, 12.911987%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.198425%, 6.098938%, 12.684631%)",
    offset: 0.480469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.998535%, 5.899048%, 12.471008%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.798645%, 5.899048%, 12.335205%)",
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.598755%, 5.899048%, 12.199402%)",
    offset: 0.492187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.598755%, 5.699158%, 11.999512%)",
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.598755%, 5.499268%, 11.799622%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.398865%, 5.499268%, 11.799622%)",
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.198975%, 5.499268%, 11.799622%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.198975%, 5.499268%, 11.599731%)",
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.198975%, 5.499268%, 11.399841%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.999084%, 5.299377%, 11.198425%)",
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.799194%, 5.099487%, 10.998535%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.599304%, 5.099487%, 10.798645%)",
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.399414%, 5.099487%, 10.598755%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.399414%, 5.099487%, 10.595703%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.205627%, 4.905701%, 10.395813%)",
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.011841%, 4.711914%, 10.198975%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.005737%, 4.705811%, 10.014343%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.799744%, 4.699707%, 9.814453%)",
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.599854%, 4.699707%, 9.799194%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.583069%, 4.499817%, 9.584045%)",
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.56781%, 4.299927%, 9.368896%)",
    offset: 0.570313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.383179%, 4.299927%, 9.184265%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.198547%, 4.299927%, 8.802795%)",
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.198547%, 4.299927%, 8.605957%)",
    offset: 0.585937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.998657%, 4.112244%, 8.602905%)",
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.798767%, 3.924561%, 8.599854%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.798767%, 3.910828%, 8.398438%)",
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.798767%, 3.898621%, 8.198547%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.649231%, 3.898621%, 7.998657%)",
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.499695%, 3.898621%, 7.798767%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.49054%, 3.889465%, 7.791138%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.290649%, 3.689575%, 7.641602%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.099915%, 3.49884%, 7.499695%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.898499%, 3.49884%, 7.299805%)",
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.698608%, 3.49884%, 7.099915%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.677246%, 3.29895%, 6.898499%)",
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.655884%, 3.09906%, 6.698608%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.477356%, 3.09906%, 6.686401%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.298828%, 3.09906%, 6.486511%)",
    offset: 0.664063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.105042%, 2.905273%, 6.105042%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.731201%, 2.705383%, 5.731201%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.523682%, 2.687073%, 5.508423%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.493164%, 2.537537%, 5.284119%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.293274%, 2.398682%, 5.099487%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.099487%, 2.398682%, 4.899597%)",
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.099487%, 2.398682%, 4.699707%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.920959%, 2.398682%, 4.699707%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.721069%, 2.198792%, 4.499817%)",
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.699707%, 1.998901%, 4.299927%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.699707%, 1.998901%, 4.290771%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.499817%, 1.998901%, 4.089355%)",
    offset: 0.746094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.299927%, 1.998901%, 3.898621%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.299927%, 1.998901%, 3.898621%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.299927%, 1.817322%, 3.69873%)",
    offset: 0.761719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.299927%, 1.637268%, 3.49884%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.098511%, 1.617432%, 3.477478%)",
    offset: 0.769531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.898621%, 1.599121%, 3.456116%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.898621%, 1.599121%, 3.277588%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.898621%, 1.599121%, 3.09906%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.70636%, 1.599121%, 2.906799%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.50647%, 1.411438%, 2.706909%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.495789%, 1.211548%, 2.548218%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.297424%, 1.199341%, 2.398682%)",
    offset: 0.835937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.100586%, 1.199341%, 2.398682%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.09906%, 1.199341%, 2.2995%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.09906%, 1.199341%, 2.099609%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.09906%, 1.098633%, 1.998901%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.09906%, 0.898743%, 1.998901%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 312 22.410156 L 363 22.410156 L 363 195.625 L 312 195.625 Z M 312 22.410156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 312.402344 22.523438 L 362.789062 22.523438 L 362.789062 195.542969 L 312.402344 195.542969 Z M 312.402344 22.523438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 362.789062 182.726562 L 362.789062 24.105469 C 362.789062 23.566406 362.757812 23.042969 362.703125 22.523438 L 312.492188 22.523438 C 312.433594 23.042969 312.402344 23.566406 312.402344 24.105469 L 312.402344 182.726562 C 312.402344 189.804688 317.03125 195.542969 322.734375 195.542969 L 352.457031 195.542969 C 358.160156 195.542969 362.789062 189.804688 362.789062 182.726562 Z M 361.601562 182.726562 C 361.601562 189.136719 357.5 194.355469 352.457031 194.355469 L 322.734375 194.355469 C 317.691406 194.355469 313.589844 189.136719 313.589844 182.726562 L 313.589844 24.105469 C 313.589844 23.980469 313.589844 23.84375 313.59375 23.710938 L 361.597656 23.710938 C 361.601562 23.84375 361.601562 23.980469 361.601562 24.105469 L 361.601562 182.726562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 362.789062 182.726562 L 362.789062 24.105469 C 362.789062 23.566406 362.757812 23.042969 362.703125 22.523438 L 312.492188 22.523438 C 312.433594 23.042969 312.402344 23.566406 312.402344 24.105469 L 312.402344 182.726562 C 312.402344 189.804688 317.03125 195.542969 322.734375 195.542969 L 352.457031 195.542969 C 358.160156 195.542969 362.789062 189.804688 362.789062 182.726562 Z M 361.601562 182.726562 C 361.601562 189.136719 357.5 194.355469 352.457031 194.355469 L 322.734375 194.355469 C 317.691406 194.355469 313.589844 189.136719 313.589844 182.726562 L 313.589844 24.105469 C 313.589844 23.980469 313.589844 23.84375 313.59375 23.710938 L 361.597656 23.710938 C 361.601562 23.84375 361.601562 23.980469 361.601562 24.105469 L 361.601562 182.726562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 4.74786e-9,
    gradientTransform: "matrix(0.000000000000010594, 173.01823, -173.01823, 0.000000000000010594, 337.59619, 22.52483)",
    y1: 0,
    x2: 0.999992,
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    id: "id35"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.498535%, 12.89978%, 27.49939%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.498535%, 12.89978%, 27.49939%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.498535%, 12.89978%, 27.49939%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.298645%, 12.69989%, 27.2995%)",
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.098755%, 12.5%, 27.099609%)",
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.086548%, 12.5%, 26.899719%)",
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.074341%, 12.5%, 26.699829%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.883606%, 12.348938%, 26.498413%)",
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.694397%, 12.199402%, 26.298523%)",
    offset: 0.164063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.546387%, 12.199402%, 26.104736%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.198486%, 12.199402%, 25.721741%)",
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.998596%, 12.199402%, 25.531006%)",
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.82312%, 11.999512%, 25.340271%)",
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.64917%, 11.799622%, 25.149536%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.42334%, 11.782837%, 24.923706%)",
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 11.767578%, 24.699402%)",
    offset: 0.195313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.192932%, 11.582947%, 24.499512%)",
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.186829%, 11.399841%, 24.299622%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.993042%, 11.399841%, 24.299622%)",
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.599365%, 11.212158%, 24.099731%)",
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.399475%, 11.024475%, 23.899841%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.220947%, 11.010742%, 23.698425%)",
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.042419%, 10.998535%, 23.498535%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.821167%, 10.980225%, 23.280334%)",
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.599915%, 10.961914%, 23.062134%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.589233%, 10.780334%, 22.872925%)",
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.389343%, 10.598755%, 22.541809%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.998718%, 10.40802%, 22.209167%)",
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.798828%, 10.218811%, 22.018433%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.617249%, 10.20813%, 21.827698%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.217468%, 10.177612%, 21.417236%)",
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.999268%, 10.15625%, 21.199036%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.987061%, 9.977722%, 20.999146%)",
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.974854%, 9.799194%, 20.799255%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.78717%, 9.799194%, 20.599365%)",
    offset: 0.285156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.599487%, 9.799194%, 20.399475%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.453003%, 9.605408%, 20.399475%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.118835%, 9.405518%, 20.199585%)",
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.931152%, 9.399414%, 19.999695%)",
    offset: 0.304687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.914368%, 9.399414%, 19.799805%)",
    offset: 0.308594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.899109%, 9.399414%, 19.599915%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.699219%, 9.199524%, 19.398499%)",
    offset: 0.316406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.499329%, 8.999634%, 19.198608%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.299438%, 8.999634%, 18.998718%)",
    offset: 0.324219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.099548%, 8.999634%, 18.798828%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.90271%, 8.802795%, 18.60199%)",
    offset: 0.332031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.705872%, 8.605957%, 18.405151%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.70282%, 8.602905%, 18.214417%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.499878%, 8.599854%, 18.011475%)",
    offset: 0.347656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.299988%, 8.599854%, 17.999268%)",
    offset: 0.351563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.098572%, 8.398438%, 17.785645%)",
    offset: 0.355469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.898682%, 8.198547%, 17.572021%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.889526%, 8.198547%, 17.425537%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.689636%, 7.998657%, 17.089844%)",
    offset: 0.371094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.498901%, 7.800293%, 16.899109%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.308167%, 7.798767%, 16.708374%)",
    offset: 0.382813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.108276%, 7.798767%, 16.326904%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.899231%, 7.649231%, 16.096497%)",
    offset: 0.394531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.699341%, 7.499695%, 16.055298%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.499451%, 7.499695%, 15.864563%)",
    offset: 0.402344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.299561%, 7.499695%, 15.673828%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.296509%, 7.299805%, 15.486145%)",
    offset: 0.410156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.293457%, 7.099915%, 15.299988%)",
    offset: 0.414063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.096619%, 7.099915%, 15.106201%)",
    offset: 0.417969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.89978%, 7.099915%, 14.912415%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.715149%, 7.099915%, 14.72168%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.515259%, 6.924438%, 14.51416%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.348938%, 6.723022%, 14.283752%)",
    offset: 0.441406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.199402%, 6.698608%, 14.068604%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.999512%, 6.692505%, 13.883972%)",
    offset: 0.449219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.799622%, 6.686401%, 13.699341%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.799622%, 6.492615%, 13.502502%)",
    offset: 0.457031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.799622%, 6.298828%, 13.305664%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.599731%, 6.298828%, 13.114929%)",
    offset: 0.464844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.399841%, 6.298828%, 12.924194%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.399841%, 6.298828%, 12.911987%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.198425%, 6.098938%, 12.684631%)",
    offset: 0.480469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.998535%, 5.899048%, 12.471008%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.798645%, 5.899048%, 12.335205%)",
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.598755%, 5.899048%, 12.199402%)",
    offset: 0.492187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.598755%, 5.699158%, 11.999512%)",
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.598755%, 5.499268%, 11.799622%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.398865%, 5.499268%, 11.799622%)",
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.198975%, 5.499268%, 11.799622%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.198975%, 5.499268%, 11.599731%)",
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.198975%, 5.499268%, 11.399841%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.999084%, 5.299377%, 11.198425%)",
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.799194%, 5.099487%, 10.998535%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.599304%, 5.099487%, 10.798645%)",
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.399414%, 5.099487%, 10.598755%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.399414%, 5.099487%, 10.595703%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.205627%, 4.905701%, 10.395813%)",
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.011841%, 4.711914%, 10.198975%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.005737%, 4.705811%, 10.014343%)",
    offset: 0.554687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.799744%, 4.699707%, 9.814453%)",
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.599854%, 4.699707%, 9.799194%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.583069%, 4.499817%, 9.584045%)",
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.56781%, 4.299927%, 9.368896%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.383179%, 4.299927%, 9.184265%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.198547%, 4.299927%, 8.802795%)",
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.198547%, 4.299927%, 8.605957%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.998657%, 4.112244%, 8.602905%)",
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.798767%, 3.924561%, 8.599854%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.798767%, 3.910828%, 8.398438%)",
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.798767%, 3.898621%, 8.198547%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.649231%, 3.898621%, 7.998657%)",
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.499695%, 3.898621%, 7.798767%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.49054%, 3.889465%, 7.791138%)",
    offset: 0.617187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.290649%, 3.689575%, 7.641602%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.099915%, 3.49884%, 7.499695%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.898499%, 3.49884%, 7.299805%)",
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.698608%, 3.49884%, 7.099915%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.677246%, 3.29895%, 6.898499%)",
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.655884%, 3.09906%, 6.698608%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.477356%, 3.09906%, 6.686401%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.298828%, 3.09906%, 6.486511%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.105042%, 2.905273%, 6.105042%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.731201%, 2.705383%, 5.731201%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.523682%, 2.687073%, 5.508423%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.493164%, 2.537537%, 5.284119%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.293274%, 2.398682%, 5.099487%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.099487%, 2.398682%, 4.899597%)",
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.099487%, 2.398682%, 4.699707%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.920959%, 2.398682%, 4.699707%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.721069%, 2.198792%, 4.499817%)",
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.699707%, 1.998901%, 4.299927%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.699707%, 1.998901%, 4.290771%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.499817%, 1.998901%, 4.089355%)",
    offset: 0.746094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.299927%, 1.998901%, 3.898621%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.299927%, 1.998901%, 3.898621%)",
    offset: 0.757813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.299927%, 1.817322%, 3.69873%)",
    offset: 0.761719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.299927%, 1.637268%, 3.49884%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.098511%, 1.617432%, 3.477478%)",
    offset: 0.769531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.898621%, 1.599121%, 3.456116%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.898621%, 1.599121%, 3.277588%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.898621%, 1.599121%, 3.09906%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.70636%, 1.599121%, 2.906799%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.50647%, 1.411438%, 2.706909%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.495789%, 1.211548%, 2.548218%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.297424%, 1.199341%, 2.398682%)",
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.100586%, 1.199341%, 2.398682%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.09906%, 1.199341%, 2.2995%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.09906%, 1.199341%, 2.099609%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.09906%, 1.098633%, 1.998901%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.09906%, 0.898743%, 1.998901%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 362 22.410156 L 375 22.410156 L 375 195.625 L 362 195.625 Z M 362 22.410156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 362.789062 22.523438 L 375 22.523438 L 375 195.542969 L 362.789062 195.542969 Z M 362.789062 22.523438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 413.179688 182.726562 L 413.179688 24.105469 C 413.179688 23.566406 413.144531 23.042969 413.09375 22.523438 L 362.875 22.523438 C 362.824219 23.042969 362.789062 23.566406 362.789062 24.105469 L 362.789062 182.726562 C 362.789062 189.804688 367.417969 195.542969 373.125 195.542969 L 402.839844 195.542969 C 408.550781 195.542969 413.179688 189.804688 413.179688 182.726562 Z M 411.992188 182.726562 C 411.992188 189.136719 407.890625 194.355469 402.839844 194.355469 L 373.125 194.355469 C 368.082031 194.355469 363.972656 189.136719 363.972656 182.726562 L 363.972656 24.105469 C 363.972656 23.980469 363.980469 23.84375 363.984375 23.710938 L 411.988281 23.710938 C 411.992188 23.84375 411.992188 23.980469 411.992188 24.105469 L 411.992188 182.726562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 413.179688 182.726562 L 413.179688 24.105469 C 413.179688 23.566406 413.144531 23.042969 413.09375 22.523438 L 362.875 22.523438 C 362.824219 23.042969 362.789062 23.566406 362.789062 24.105469 L 362.789062 182.726562 C 362.789062 189.804688 367.417969 195.542969 373.125 195.542969 L 402.839844 195.542969 C 408.550781 195.542969 413.179688 189.804688 413.179688 182.726562 Z M 411.992188 182.726562 C 411.992188 189.136719 407.890625 194.355469 402.839844 194.355469 L 373.125 194.355469 C 368.082031 194.355469 363.972656 189.136719 363.972656 182.726562 L 363.972656 24.105469 C 363.972656 23.980469 363.980469 23.84375 363.984375 23.710938 L 411.988281 23.710938 C 411.992188 23.84375 411.992188 23.980469 411.992188 24.105469 L 411.992188 182.726562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 4.74786e-9,
    gradientTransform: "matrix(0.000000000000010594, 173.01823, -173.01823, 0.000000000000010594, 387.98511, 22.52483)",
    y1: 0,
    x2: 0.999992,
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    id: "id40"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.498535%, 12.89978%, 27.49939%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.498535%, 12.89978%, 27.49939%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.498535%, 12.89978%, 27.49939%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.298645%, 12.69989%, 27.2995%)",
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.098755%, 12.5%, 27.099609%)",
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.086548%, 12.5%, 26.899719%)",
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.074341%, 12.5%, 26.699829%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.883606%, 12.348938%, 26.498413%)",
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.694397%, 12.199402%, 26.298523%)",
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.546387%, 12.199402%, 26.104736%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.198486%, 12.199402%, 25.721741%)",
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.998596%, 12.199402%, 25.531006%)",
    offset: 0.179687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.82312%, 11.999512%, 25.340271%)",
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.64917%, 11.799622%, 25.149536%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.42334%, 11.782837%, 24.923706%)",
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 11.767578%, 24.699402%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.192932%, 11.582947%, 24.499512%)",
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.186829%, 11.399841%, 24.299622%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.993042%, 11.399841%, 24.299622%)",
    offset: 0.210937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.599365%, 11.212158%, 24.099731%)",
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.399475%, 11.024475%, 23.899841%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.220947%, 11.010742%, 23.698425%)",
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.042419%, 10.998535%, 23.498535%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.821167%, 10.980225%, 23.280334%)",
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.599915%, 10.961914%, 23.062134%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.589233%, 10.780334%, 22.872925%)",
    offset: 0.242187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.389343%, 10.598755%, 22.541809%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.998718%, 10.40802%, 22.209167%)",
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.798828%, 10.218811%, 22.018433%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.617249%, 10.20813%, 21.827698%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.217468%, 10.177612%, 21.417236%)",
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.999268%, 10.15625%, 21.199036%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.987061%, 9.977722%, 20.999146%)",
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.974854%, 9.799194%, 20.799255%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.78717%, 9.799194%, 20.599365%)",
    offset: 0.285156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.599487%, 9.799194%, 20.399475%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.453003%, 9.605408%, 20.399475%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.118835%, 9.405518%, 20.199585%)",
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.931152%, 9.399414%, 19.999695%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.914368%, 9.399414%, 19.799805%)",
    offset: 0.308594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.899109%, 9.399414%, 19.599915%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.699219%, 9.199524%, 19.398499%)",
    offset: 0.316406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.499329%, 8.999634%, 19.198608%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.299438%, 8.999634%, 18.998718%)",
    offset: 0.324219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.099548%, 8.999634%, 18.798828%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.90271%, 8.802795%, 18.60199%)",
    offset: 0.332031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.705872%, 8.605957%, 18.405151%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.70282%, 8.602905%, 18.214417%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.499878%, 8.599854%, 18.011475%)",
    offset: 0.347656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.299988%, 8.599854%, 17.999268%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.098572%, 8.398438%, 17.785645%)",
    offset: 0.355469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.898682%, 8.198547%, 17.572021%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.889526%, 8.198547%, 17.425537%)",
    offset: 0.367187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.689636%, 7.998657%, 17.089844%)",
    offset: 0.371094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.498901%, 7.800293%, 16.899109%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.308167%, 7.798767%, 16.708374%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.108276%, 7.798767%, 16.326904%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.899231%, 7.649231%, 16.096497%)",
    offset: 0.394531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.699341%, 7.499695%, 16.055298%)",
    offset: 0.398437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.499451%, 7.499695%, 15.864563%)",
    offset: 0.402344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.299561%, 7.499695%, 15.673828%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.296509%, 7.299805%, 15.486145%)",
    offset: 0.410156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.293457%, 7.099915%, 15.299988%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.096619%, 7.099915%, 15.106201%)",
    offset: 0.417969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.89978%, 7.099915%, 14.912415%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.715149%, 7.099915%, 14.72168%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.515259%, 6.924438%, 14.51416%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.348938%, 6.723022%, 14.283752%)",
    offset: 0.441406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.199402%, 6.698608%, 14.068604%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.999512%, 6.692505%, 13.883972%)",
    offset: 0.449219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.799622%, 6.686401%, 13.699341%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.799622%, 6.492615%, 13.502502%)",
    offset: 0.457031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.799622%, 6.298828%, 13.305664%)",
    offset: 0.460937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.599731%, 6.298828%, 13.114929%)",
    offset: 0.464844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.399841%, 6.298828%, 12.924194%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.399841%, 6.298828%, 12.911987%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.198425%, 6.098938%, 12.684631%)",
    offset: 0.480469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.998535%, 5.899048%, 12.471008%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.798645%, 5.899048%, 12.335205%)",
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.598755%, 5.899048%, 12.199402%)",
    offset: 0.492187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.598755%, 5.699158%, 11.999512%)",
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.598755%, 5.499268%, 11.799622%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.398865%, 5.499268%, 11.799622%)",
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.198975%, 5.499268%, 11.799622%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.198975%, 5.499268%, 11.599731%)",
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.198975%, 5.499268%, 11.399841%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.999084%, 5.299377%, 11.198425%)",
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.799194%, 5.099487%, 10.998535%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.599304%, 5.099487%, 10.798645%)",
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.399414%, 5.099487%, 10.598755%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.399414%, 5.099487%, 10.595703%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.205627%, 4.905701%, 10.395813%)",
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.011841%, 4.711914%, 10.198975%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.005737%, 4.705811%, 10.014343%)",
    offset: 0.554687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.799744%, 4.699707%, 9.814453%)",
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.599854%, 4.699707%, 9.799194%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.583069%, 4.499817%, 9.584045%)",
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.56781%, 4.299927%, 9.368896%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.383179%, 4.299927%, 9.184265%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.198547%, 4.299927%, 8.802795%)",
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.198547%, 4.299927%, 8.605957%)",
    offset: 0.585937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.998657%, 4.112244%, 8.602905%)",
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.798767%, 3.924561%, 8.599854%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.798767%, 3.910828%, 8.398438%)",
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.798767%, 3.898621%, 8.198547%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.649231%, 3.898621%, 7.998657%)",
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.499695%, 3.898621%, 7.798767%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.49054%, 3.889465%, 7.791138%)",
    offset: 0.617187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.290649%, 3.689575%, 7.641602%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.099915%, 3.49884%, 7.499695%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.898499%, 3.49884%, 7.299805%)",
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.698608%, 3.49884%, 7.099915%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.677246%, 3.29895%, 6.898499%)",
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.655884%, 3.09906%, 6.698608%)",
    offset: 0.648437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.477356%, 3.09906%, 6.686401%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.298828%, 3.09906%, 6.486511%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.105042%, 2.905273%, 6.105042%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.731201%, 2.705383%, 5.731201%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.523682%, 2.687073%, 5.508423%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.493164%, 2.537537%, 5.284119%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.293274%, 2.398682%, 5.099487%)",
    offset: 0.710937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.099487%, 2.398682%, 4.899597%)",
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.099487%, 2.398682%, 4.699707%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.920959%, 2.398682%, 4.699707%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.721069%, 2.198792%, 4.499817%)",
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.699707%, 1.998901%, 4.299927%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.699707%, 1.998901%, 4.290771%)",
    offset: 0.742187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.499817%, 1.998901%, 4.089355%)",
    offset: 0.746094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.299927%, 1.998901%, 3.898621%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.299927%, 1.998901%, 3.898621%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.299927%, 1.817322%, 3.69873%)",
    offset: 0.761719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.299927%, 1.637268%, 3.49884%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.098511%, 1.617432%, 3.477478%)",
    offset: 0.769531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.898621%, 1.599121%, 3.456116%)",
    offset: 0.773437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.898621%, 1.599121%, 3.277588%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.898621%, 1.599121%, 3.09906%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.70636%, 1.599121%, 2.906799%)",
    offset: 0.804687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.50647%, 1.411438%, 2.706909%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.495789%, 1.211548%, 2.548218%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.297424%, 1.199341%, 2.398682%)",
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.100586%, 1.199341%, 2.398682%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.09906%, 1.199341%, 2.2995%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.09906%, 1.199341%, 2.099609%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.09906%, 1.098633%, 1.998901%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.09906%, 0.898743%, 1.998901%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 45 22.410156 L 76 22.410156 L 76 122 L 45 122 Z M 45 22.410156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 95 22.410156 L 126 22.410156 L 126 122 L 95 122 Z M 95 22.410156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 196 22.410156 L 227 22.410156 L 227 122 L 196 122 Z M 196 22.410156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 247 22.410156 L 278 22.410156 L 278 122 L 247 122 Z M 247 22.410156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 297 22.410156 L 328 22.410156 L 328 122 L 297 122 Z M 297 22.410156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 362.644531 18.058594 L 375 18.058594 L 375 202.609375 L 362.644531 202.609375 Z M 362.644531 18.058594 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 60.457031 182.726562 L 60.457031 24.105469 C 60.457031 23.566406 60.421875 23.042969 60.375 22.523438 L 10.15625 22.523438 C 10.105469 23.042969 10.070312 23.566406 10.070312 24.105469 L 10.070312 182.726562 C 10.070312 189.804688 14.699219 195.542969 20.402344 195.542969 L 50.125 195.542969 C 55.832031 195.542969 60.457031 189.804688 60.457031 182.726562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#id5)",
    d: "M 60.457031 22.523438 L 10.070312 22.523438 L 10.070312 195.542969 L 60.457031 195.542969 Z M 60.457031 22.523438 ",
    fillRule: "nonzero"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 110.847656 182.726562 L 110.847656 24.105469 C 110.847656 23.566406 110.808594 23.042969 110.765625 22.523438 L 60.546875 22.523438 C 60.492188 23.042969 60.457031 23.566406 60.457031 24.105469 L 60.457031 182.726562 C 60.457031 189.804688 65.089844 195.542969 70.792969 195.542969 L 100.507812 195.542969 C 106.21875 195.542969 110.847656 189.804688 110.847656 182.726562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#id10)",
    d: "M 110.847656 22.523438 L 60.457031 22.523438 L 60.457031 195.542969 L 110.847656 195.542969 Z M 110.847656 22.523438 ",
    fillRule: "nonzero"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id11)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 161.238281 182.726562 L 161.238281 24.105469 C 161.238281 23.566406 161.199219 23.042969 161.148438 22.523438 L 110.933594 22.523438 C 110.882812 23.042969 110.847656 23.566406 110.847656 24.105469 L 110.847656 182.726562 C 110.847656 189.804688 115.472656 195.542969 121.183594 195.542969 L 150.898438 195.542969 C 156.605469 195.542969 161.238281 189.804688 161.238281 182.726562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id12)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id13)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id14)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#id15)",
    d: "M 161.238281 22.523438 L 110.847656 22.523438 L 110.847656 195.542969 L 161.238281 195.542969 Z M 161.238281 22.523438 ",
    fillRule: "nonzero"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id16)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 211.621094 182.726562 L 211.621094 24.105469 C 211.621094 23.566406 211.589844 23.042969 211.539062 22.523438 L 161.324219 22.523438 C 161.273438 23.042969 161.238281 23.566406 161.238281 24.105469 L 161.238281 182.726562 C 161.238281 189.804688 165.863281 195.542969 171.570312 195.542969 L 201.285156 195.542969 C 206.996094 195.542969 211.621094 189.804688 211.621094 182.726562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id17)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id18)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id19)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#id20)",
    d: "M 211.621094 22.523438 L 161.238281 22.523438 L 161.238281 195.542969 L 211.621094 195.542969 Z M 211.621094 22.523438 ",
    fillRule: "nonzero"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id21)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 262.011719 182.726562 L 262.011719 24.105469 C 262.011719 23.566406 261.976562 23.042969 261.925781 22.523438 L 211.710938 22.523438 C 211.660156 23.042969 211.621094 23.566406 211.621094 24.105469 L 211.621094 182.726562 C 211.621094 189.804688 216.253906 195.542969 221.960938 195.542969 L 251.675781 195.542969 C 257.386719 195.542969 262.011719 189.804688 262.011719 182.726562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id22)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id23)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id24)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#id25)",
    d: "M 262.011719 22.523438 L 211.621094 22.523438 L 211.621094 195.542969 L 262.011719 195.542969 Z M 262.011719 22.523438 ",
    fillRule: "nonzero"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id26)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 312.402344 182.726562 L 312.402344 24.105469 C 312.402344 23.566406 312.367188 23.042969 312.316406 22.523438 L 262.101562 22.523438 C 262.050781 23.042969 262.011719 23.566406 262.011719 24.105469 L 262.011719 182.726562 C 262.011719 189.804688 266.640625 195.542969 272.351562 195.542969 L 302.066406 195.542969 C 307.777344 195.542969 312.402344 189.804688 312.402344 182.726562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id27)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id28)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id29)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#id30)",
    d: "M 312.402344 22.523438 L 262.011719 22.523438 L 262.011719 195.542969 L 312.402344 195.542969 Z M 312.402344 22.523438 ",
    fillRule: "nonzero"
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id31)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 362.789062 182.726562 L 362.789062 24.105469 C 362.789062 23.566406 362.757812 23.042969 362.703125 22.523438 L 312.492188 22.523438 C 312.433594 23.042969 312.402344 23.566406 312.402344 24.105469 L 312.402344 182.726562 C 312.402344 189.804688 317.03125 195.542969 322.734375 195.542969 L 352.457031 195.542969 C 358.160156 195.542969 362.789062 189.804688 362.789062 182.726562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id32)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id33)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id34)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#id35)",
    d: "M 362.789062 22.523438 L 312.402344 22.523438 L 312.402344 195.542969 L 362.789062 195.542969 Z M 362.789062 22.523438 ",
    fillRule: "nonzero"
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id36)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 413.179688 182.726562 L 413.179688 24.105469 C 413.179688 23.566406 413.144531 23.042969 413.09375 22.523438 L 362.875 22.523438 C 362.824219 23.042969 362.789062 23.566406 362.789062 24.105469 L 362.789062 182.726562 C 362.789062 189.804688 367.417969 195.542969 373.125 195.542969 L 402.839844 195.542969 C 408.550781 195.542969 413.179688 189.804688 413.179688 182.726562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id37)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id38)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id39)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#id40)",
    d: "M 375 22.523438 L 362.789062 22.523438 L 362.789062 195.542969 L 375 195.542969 Z M 375 22.523438 ",
    fillRule: "nonzero"
  }))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id41)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 75.46875 113.40625 L 75.46875 22.523438 L 45.449219 22.523438 L 45.449219 113.40625 C 45.449219 117.621094 48.207031 121.039062 51.605469 121.039062 L 69.308594 121.039062 C 72.707031 121.039062 75.46875 117.621094 75.46875 113.40625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id42)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 125.851562 113.40625 L 125.851562 22.523438 L 95.839844 22.523438 L 95.839844 113.40625 C 95.839844 117.621094 98.597656 121.039062 101.996094 121.039062 L 119.699219 121.039062 C 123.097656 121.039062 125.851562 117.621094 125.851562 113.40625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id43)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 226.632812 113.40625 L 226.632812 22.523438 L 196.617188 22.523438 L 196.617188 113.40625 C 196.617188 117.621094 199.371094 121.039062 202.773438 121.039062 L 220.472656 121.039062 C 223.871094 121.039062 226.632812 117.621094 226.632812 113.40625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id44)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 277.019531 113.40625 L 277.019531 22.523438 L 247.007812 22.523438 L 247.007812 113.40625 C 247.007812 117.621094 249.761719 121.039062 253.160156 121.039062 L 270.863281 121.039062 C 274.261719 121.039062 277.019531 117.621094 277.019531 113.40625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id45)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 327.410156 113.40625 L 327.410156 22.523438 L 297.390625 22.523438 L 297.390625 113.40625 C 297.390625 117.621094 300.152344 121.039062 303.550781 121.039062 L 321.253906 121.039062 C 324.652344 121.039062 327.410156 117.621094 327.410156 113.40625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id46)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 362.644531 18.058594 L 525.777344 18.058594 L 525.777344 202.609375 L 362.644531 202.609375 L 362.644531 18.058594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.74132, 175.700802)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 7.625 -10.921875 C 6.738281 -10.921875 6.046875 -10.554688 5.546875 -9.828125 C 5.054688 -9.109375 4.8125 -8.113281 4.8125 -6.84375 C 4.8125 -4.1875 5.820312 -2.859375 7.84375 -2.859375 C 8.445312 -2.859375 9.035156 -2.941406 9.609375 -3.109375 C 10.179688 -3.273438 10.753906 -3.476562 11.328125 -3.71875 L 11.328125 -0.578125 C 10.179688 -0.0664062 8.882812 0.1875 7.4375 0.1875 C 5.351562 0.1875 3.753906 -0.414062 2.640625 -1.625 C 1.535156 -2.832031 0.984375 -4.578125 0.984375 -6.859375 C 0.984375 -8.285156 1.25 -9.535156 1.78125 -10.609375 C 2.320312 -11.691406 3.097656 -12.523438 4.109375 -13.109375 C 5.117188 -13.691406 6.304688 -13.984375 7.671875 -13.984375 C 9.160156 -13.984375 10.582031 -13.660156 11.9375 -13.015625 L 10.796875 -10.078125 C 10.285156 -10.316406 9.773438 -10.515625 9.265625 -10.671875 C 8.753906 -10.835938 8.207031 -10.921875 7.625 -10.921875 Z M 7.625 -10.921875 "
  }))))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffd03c",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.057993, 60.685621)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 6.96875 -9.984375 C 6.15625 -9.984375 5.519531 -9.648438 5.0625 -8.984375 C 4.613281 -8.328125 4.390625 -7.414062 4.390625 -6.25 C 4.390625 -3.820312 5.3125 -2.609375 7.15625 -2.609375 C 7.71875 -2.609375 8.257812 -2.6875 8.78125 -2.84375 C 9.300781 -3 9.828125 -3.1875 10.359375 -3.40625 L 10.359375 -0.53125 C 9.304688 -0.0625 8.113281 0.171875 6.78125 0.171875 C 4.882812 0.171875 3.425781 -0.378906 2.40625 -1.484375 C 1.394531 -2.585938 0.890625 -4.179688 0.890625 -6.265625 C 0.890625 -7.566406 1.132812 -8.710938 1.625 -9.703125 C 2.125 -10.691406 2.832031 -11.453125 3.75 -11.984375 C 4.675781 -12.515625 5.757812 -12.78125 7 -12.78125 C 8.363281 -12.78125 9.664062 -12.484375 10.90625 -11.890625 L 9.859375 -9.203125 C 9.398438 -9.421875 8.9375 -9.601562 8.46875 -9.75 C 8 -9.90625 7.5 -9.984375 6.96875 -9.984375 Z M 6.96875 -9.984375 "
  }))))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffd03c",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.502793, 60.685621)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 13.402344 -9.292969 L 13.402344 -10.757812 L 11.023438 -10.421875 L 11.023438 -14.425781 L 10.335938 -14.425781 L 10.335938 -10.316406 L 7.25 -9.875 L 7.25 -13.878906 L 6.5625 -13.878906 L 6.5625 -9.769531 L 4.164062 -9.417969 L 4.164062 -7.9375 L 6.5625 -8.289062 L 6.5625 -4.671875 L 4.164062 -4.320312 L 4.164062 -2.855469 L 6.5625 -3.210938 L 6.5625 0.988281 L 7.25 0.988281 L 7.25 -3.316406 L 10.335938 -3.757812 L 10.335938 0.441406 L 11.023438 0.441406 L 11.023438 -3.863281 L 13.402344 -4.199219 L 13.402344 -5.679688 L 11.023438 -5.328125 L 11.023438 -8.941406 Z M 10.335938 -5.21875 L 7.25 -4.78125 L 7.25 -8.394531 L 10.335938 -8.835938 Z M 10.335938 -5.21875 "
  }))))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(79.918751, 175.700802)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 13.1875 -7.1875 C 13.1875 -4.882812 12.550781 -3.109375 11.28125 -1.859375 C 10.019531 -0.617188 8.242188 0 5.953125 0 L 1.484375 0 L 1.484375 -13.78125 L 6.265625 -13.78125 C 8.472656 -13.78125 10.175781 -13.210938 11.375 -12.078125 C 12.582031 -10.953125 13.1875 -9.320312 13.1875 -7.1875 Z M 9.328125 -7.046875 C 9.328125 -8.316406 9.078125 -9.253906 8.578125 -9.859375 C 8.078125 -10.472656 7.316406 -10.78125 6.296875 -10.78125 L 5.21875 -10.78125 L 5.21875 -3.0625 L 6.046875 -3.0625 C 7.171875 -3.0625 8 -3.390625 8.53125 -4.046875 C 9.0625 -4.703125 9.328125 -5.703125 9.328125 -7.046875 Z M 9.328125 -7.046875 "
  }))))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(131.736499, 175.700802)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 9.671875 0 L 1.484375 0 L 1.484375 -13.78125 L 9.671875 -13.78125 L 9.671875 -10.796875 L 5.21875 -10.796875 L 5.21875 -8.625 L 9.34375 -8.625 L 9.34375 -5.640625 L 5.21875 -5.640625 L 5.21875 -3.03125 L 9.671875 -3.03125 Z M 9.671875 0 "
  }))))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(179.978371, 175.700802)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 5.15625 0 L 1.484375 0 L 1.484375 -13.78125 L 9.640625 -13.78125 L 9.640625 -10.796875 L 5.15625 -10.796875 L 5.15625 -8.171875 L 9.28125 -8.171875 L 9.28125 -5.171875 L 5.15625 -5.171875 Z M 5.15625 0 "
  }))))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(228.029976, 175.700802)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 7.03125 -8.078125 L 12.96875 -8.078125 L 12.96875 -0.640625 C 11.351562 -0.0859375 9.578125 0.1875 7.640625 0.1875 C 5.515625 0.1875 3.875 -0.425781 2.71875 -1.65625 C 1.5625 -2.894531 0.984375 -4.65625 0.984375 -6.9375 C 0.984375 -9.15625 1.617188 -10.882812 2.890625 -12.125 C 4.160156 -13.363281 5.9375 -13.984375 8.21875 -13.984375 C 9.09375 -13.984375 9.910156 -13.898438 10.671875 -13.734375 C 11.441406 -13.578125 12.113281 -13.367188 12.6875 -13.109375 L 11.515625 -10.1875 C 10.523438 -10.675781 9.429688 -10.921875 8.234375 -10.921875 C 7.148438 -10.921875 6.3125 -10.566406 5.71875 -9.859375 C 5.125 -9.160156 4.828125 -8.15625 4.828125 -6.84375 C 4.828125 -5.550781 5.09375 -4.566406 5.625 -3.890625 C 6.164062 -3.210938 6.941406 -2.875 7.953125 -2.875 C 8.503906 -2.875 9.015625 -2.925781 9.484375 -3.03125 L 9.484375 -5.203125 L 7.03125 -5.203125 Z M 7.03125 -8.078125 "
  }))))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(279.972382, 175.700802)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 9.953125 0 L 9.265625 -2.578125 L 4.796875 -2.578125 L 4.09375 0 L 0 0 L 4.5 -13.84375 L 9.46875 -13.84375 L 14.015625 0 Z M 8.5 -5.640625 L 7.90625 -7.90625 C 7.757812 -8.40625 7.585938 -9.050781 7.390625 -9.84375 C 7.191406 -10.644531 7.0625 -11.222656 7 -11.578125 C 6.945312 -11.253906 6.835938 -10.722656 6.671875 -9.984375 C 6.503906 -9.253906 6.132812 -7.804688 5.5625 -5.640625 Z M 8.5 -5.640625 "
  }))))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(331.639205, 175.700802)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.484375 -13.78125 L 6.296875 -13.78125 C 8.171875 -13.78125 9.5625 -13.503906 10.46875 -12.953125 C 11.375 -12.398438 11.828125 -11.535156 11.828125 -10.359375 C 11.828125 -9.578125 11.628906 -8.910156 11.234375 -8.359375 C 10.835938 -7.816406 10.316406 -7.46875 9.671875 -7.3125 L 9.671875 -7.21875 C 10.523438 -7 11.144531 -6.625 11.53125 -6.09375 C 11.914062 -5.5625 12.109375 -4.875 12.109375 -4.03125 C 12.109375 -2.78125 11.632812 -1.796875 10.6875 -1.078125 C 9.75 -0.359375 8.472656 0 6.859375 0 L 1.484375 0 Z M 5.21875 -8.5 L 6.34375 -8.5 C 6.875 -8.5 7.285156 -8.609375 7.578125 -8.828125 C 7.867188 -9.046875 8.015625 -9.375 8.015625 -9.8125 C 8.015625 -10.582031 7.429688 -10.96875 6.265625 -10.96875 L 5.21875 -10.96875 Z M 5.21875 -5.765625 L 5.21875 -2.875 L 6.53125 -2.875 C 7.6875 -2.875 8.265625 -3.363281 8.265625 -4.34375 C 8.265625 -4.800781 8.109375 -5.148438 7.796875 -5.390625 C 7.492188 -5.640625 7.046875 -5.765625 6.453125 -5.765625 Z M 5.21875 -5.765625 "
  }))))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffd03c",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(96.790712, 60.685631)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 12.046875 -6.5625 C 12.046875 -4.457031 11.46875 -2.835938 10.3125 -1.703125 C 9.15625 -0.566406 7.53125 0 5.4375 0 L 1.359375 0 L 1.359375 -12.59375 L 5.71875 -12.59375 C 7.738281 -12.59375 9.296875 -12.070312 10.390625 -11.03125 C 11.492188 -10 12.046875 -8.507812 12.046875 -6.5625 Z M 8.515625 -6.4375 C 8.515625 -7.59375 8.285156 -8.445312 7.828125 -9 C 7.378906 -9.5625 6.6875 -9.84375 5.75 -9.84375 L 4.765625 -9.84375 L 4.765625 -2.796875 L 5.515625 -2.796875 C 6.554688 -2.796875 7.316406 -3.09375 7.796875 -3.6875 C 8.273438 -4.289062 8.515625 -5.207031 8.515625 -6.4375 Z M 8.515625 -6.4375 "
  }))))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffd03c",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(109.733927, 60.685631)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 13.402344 -9.292969 L 13.402344 -10.757812 L 11.023438 -10.421875 L 11.023438 -14.425781 L 10.335938 -14.425781 L 10.335938 -10.316406 L 7.25 -9.875 L 7.25 -13.878906 L 6.5625 -13.878906 L 6.5625 -9.769531 L 4.164062 -9.417969 L 4.164062 -7.9375 L 6.5625 -8.289062 L 6.5625 -4.671875 L 4.164062 -4.320312 L 4.164062 -2.855469 L 6.5625 -3.210938 L 6.5625 0.988281 L 7.25 0.988281 L 7.25 -3.316406 L 10.335938 -3.757812 L 10.335938 0.441406 L 11.023438 0.441406 L 11.023438 -3.863281 L 13.402344 -4.199219 L 13.402344 -5.679688 L 11.023438 -5.328125 L 11.023438 -8.941406 Z M 10.335938 -5.21875 L 7.25 -4.78125 L 7.25 -8.394531 L 10.335938 -8.835938 Z M 10.335938 -5.21875 "
  }))))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffd03c",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.815812, 104.335871)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 12.046875 -6.5625 C 12.046875 -4.457031 11.46875 -2.835938 10.3125 -1.703125 C 9.15625 -0.566406 7.53125 0 5.4375 0 L 1.359375 0 L 1.359375 -12.59375 L 5.71875 -12.59375 C 7.738281 -12.59375 9.296875 -12.070312 10.390625 -11.03125 C 11.492188 -10 12.046875 -8.507812 12.046875 -6.5625 Z M 8.515625 -6.4375 C 8.515625 -7.59375 8.285156 -8.445312 7.828125 -9 C 7.378906 -9.5625 6.6875 -9.84375 5.75 -9.84375 L 4.765625 -9.84375 L 4.765625 -2.796875 L 5.515625 -2.796875 C 6.554688 -2.796875 7.316406 -3.09375 7.796875 -3.6875 C 8.273438 -4.289062 8.515625 -5.207031 8.515625 -6.4375 Z M 8.515625 -6.4375 "
  }))))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffd03c",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.759027, 104.335871)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 10.597656 -8.359375 C 9.046875 -8.359375 7.636719 -7.285156 6.824219 -5.855469 L 6.824219 -14.390625 L 6.136719 -14.390625 L 6.136719 0.988281 L 6.296875 0.988281 C 8.625 -1.800781 13.070312 -2.539062 13.070312 -6.136719 C 13.070312 -7.371094 12.152344 -8.359375 10.597656 -8.359375 Z M 6.824219 -0.300781 L 6.824219 -4.902344 C 7.777344 -6.632812 9.011719 -7.371094 9.910156 -7.371094 C 10.707031 -7.371094 11.324219 -6.914062 11.324219 -5.835938 C 11.324219 -3.386719 8.765625 -2.398438 6.824219 -0.300781 Z M 6.824219 -0.300781 "
  }))))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffd03c",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(98.416789, 104.335871)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 8.84375 0 L 1.359375 0 L 1.359375 -12.59375 L 8.84375 -12.59375 L 8.84375 -9.859375 L 4.765625 -9.859375 L 4.765625 -7.875 L 8.53125 -7.875 L 8.53125 -5.15625 L 4.765625 -5.15625 L 4.765625 -2.78125 L 8.84375 -2.78125 Z M 8.84375 0 "
  }))))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffd03c",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(108.096213, 104.335871)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 10.597656 -8.359375 C 9.046875 -8.359375 7.636719 -7.285156 6.824219 -5.855469 L 6.824219 -14.390625 L 6.136719 -14.390625 L 6.136719 0.988281 L 6.296875 0.988281 C 8.625 -1.800781 13.070312 -2.539062 13.070312 -6.136719 C 13.070312 -7.371094 12.152344 -8.359375 10.597656 -8.359375 Z M 6.824219 -0.300781 L 6.824219 -4.902344 C 7.777344 -6.632812 9.011719 -7.371094 9.910156 -7.371094 C 10.707031 -7.371094 11.324219 -6.914062 11.324219 -5.835938 C 11.324219 -3.386719 8.765625 -2.398438 6.824219 -0.300781 Z M 6.824219 -0.300781 "
  }))))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffd03c",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(199.167222, 60.685631)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 4.71875 0 L 1.359375 0 L 1.359375 -12.59375 L 8.796875 -12.59375 L 8.796875 -9.859375 L 4.71875 -9.859375 L 4.71875 -7.453125 L 8.484375 -7.453125 L 8.484375 -4.734375 L 4.71875 -4.734375 Z M 4.71875 0 "
  }))))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffd03c",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(208.674414, 60.685631)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 13.402344 -9.292969 L 13.402344 -10.757812 L 11.023438 -10.421875 L 11.023438 -14.425781 L 10.335938 -14.425781 L 10.335938 -10.316406 L 7.25 -9.875 L 7.25 -13.878906 L 6.5625 -13.878906 L 6.5625 -9.769531 L 4.164062 -9.417969 L 4.164062 -7.9375 L 6.5625 -8.289062 L 6.5625 -4.671875 L 4.164062 -4.320312 L 4.164062 -2.855469 L 6.5625 -3.210938 L 6.5625 0.988281 L 7.25 0.988281 L 7.25 -3.316406 L 10.335938 -3.757812 L 10.335938 0.441406 L 11.023438 0.441406 L 11.023438 -3.863281 L 13.402344 -4.199219 L 13.402344 -5.679688 L 11.023438 -5.328125 L 11.023438 -8.941406 Z M 10.335938 -5.21875 L 7.25 -4.78125 L 7.25 -8.394531 L 10.335938 -8.835938 Z M 10.335938 -5.21875 "
  }))))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffd03c",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(197.391282, 106.373565)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 6.421875 -7.375 L 11.859375 -7.375 L 11.859375 -0.578125 C 10.378906 -0.078125 8.753906 0.171875 6.984375 0.171875 C 5.046875 0.171875 3.546875 -0.390625 2.484375 -1.515625 C 1.421875 -2.640625 0.890625 -4.242188 0.890625 -6.328125 C 0.890625 -8.359375 1.46875 -9.941406 2.625 -11.078125 C 3.789062 -12.210938 5.421875 -12.78125 7.515625 -12.78125 C 8.304688 -12.78125 9.050781 -12.703125 9.75 -12.546875 C 10.457031 -12.398438 11.070312 -12.210938 11.59375 -11.984375 L 10.515625 -9.3125 C 9.609375 -9.757812 8.613281 -9.984375 7.53125 -9.984375 C 6.53125 -9.984375 5.757812 -9.660156 5.21875 -9.015625 C 4.675781 -8.367188 4.40625 -7.445312 4.40625 -6.25 C 4.40625 -5.070312 4.648438 -4.171875 5.140625 -3.546875 C 5.640625 -2.929688 6.347656 -2.625 7.265625 -2.625 C 7.773438 -2.625 8.242188 -2.675781 8.671875 -2.78125 L 8.671875 -4.75 L 6.421875 -4.75 Z M 6.421875 -7.375 "
  }))))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffd03c",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(210.446448, 106.373565)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 10.597656 -8.359375 C 9.046875 -8.359375 7.636719 -7.285156 6.824219 -5.855469 L 6.824219 -14.390625 L 6.136719 -14.390625 L 6.136719 0.988281 L 6.296875 0.988281 C 8.625 -1.800781 13.070312 -2.539062 13.070312 -6.136719 C 13.070312 -7.371094 12.152344 -8.359375 10.597656 -8.359375 Z M 6.824219 -0.300781 L 6.824219 -4.902344 C 7.777344 -6.632812 9.011719 -7.371094 9.910156 -7.371094 C 10.707031 -7.371094 11.324219 -6.914062 11.324219 -5.835938 C 11.324219 -3.386719 8.765625 -2.398438 6.824219 -0.300781 Z M 6.824219 -0.300781 "
  }))))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffd03c",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(247.938314, 106.373565)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 9.09375 0 L 8.46875 -2.359375 L 4.375 -2.359375 L 3.734375 0 L 0 0 L 4.109375 -12.640625 L 8.640625 -12.640625 L 12.8125 0 Z M 7.765625 -5.15625 L 7.21875 -7.21875 C 7.09375 -7.675781 6.9375 -8.269531 6.75 -9 C 6.570312 -9.726562 6.457031 -10.25 6.40625 -10.5625 C 6.351562 -10.269531 6.25 -9.785156 6.09375 -9.109375 C 5.9375 -8.441406 5.597656 -7.125 5.078125 -5.15625 Z M 7.765625 -5.15625 "
  }))))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffd03c",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(260.743744, 106.373565)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 10.597656 -8.359375 C 9.046875 -8.359375 7.636719 -7.285156 6.824219 -5.855469 L 6.824219 -14.390625 L 6.136719 -14.390625 L 6.136719 0.988281 L 6.296875 0.988281 C 8.625 -1.800781 13.070312 -2.539062 13.070312 -6.136719 C 13.070312 -7.371094 12.152344 -8.359375 10.597656 -8.359375 Z M 6.824219 -0.300781 L 6.824219 -4.902344 C 7.777344 -6.632812 9.011719 -7.371094 9.910156 -7.371094 C 10.707031 -7.371094 11.324219 -6.914062 11.324219 -5.835938 C 11.324219 -3.386719 8.765625 -2.398438 6.824219 -0.300781 Z M 6.824219 -0.300781 "
  }))))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffd03c",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(300.067702, 106.373565)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.359375 -12.59375 L 5.75 -12.59375 C 7.46875 -12.59375 8.738281 -12.335938 9.5625 -11.828125 C 10.394531 -11.316406 10.8125 -10.523438 10.8125 -9.453125 C 10.8125 -8.742188 10.628906 -8.140625 10.265625 -7.640625 C 9.898438 -7.148438 9.425781 -6.832031 8.84375 -6.6875 L 8.84375 -6.59375 C 9.625 -6.382812 10.1875 -6.039062 10.53125 -5.5625 C 10.882812 -5.082031 11.0625 -4.457031 11.0625 -3.6875 C 11.0625 -2.539062 10.628906 -1.640625 9.765625 -0.984375 C 8.910156 -0.328125 7.742188 0 6.265625 0 L 1.359375 0 Z M 4.765625 -7.765625 L 5.78125 -7.765625 C 6.269531 -7.765625 6.648438 -7.863281 6.921875 -8.0625 C 7.191406 -8.257812 7.328125 -8.554688 7.328125 -8.953125 C 7.328125 -9.660156 6.789062 -10.015625 5.71875 -10.015625 L 4.765625 -10.015625 Z M 4.765625 -5.265625 L 4.765625 -2.625 L 5.953125 -2.625 C 7.015625 -2.625 7.546875 -3.070312 7.546875 -3.96875 C 7.546875 -4.382812 7.40625 -4.703125 7.125 -4.921875 C 6.84375 -5.148438 6.429688 -5.265625 5.890625 -5.265625 Z M 4.765625 -5.265625 "
  }))))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffd03c",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(311.951693, 106.373565)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 10.597656 -8.359375 C 9.046875 -8.359375 7.636719 -7.285156 6.824219 -5.855469 L 6.824219 -14.390625 L 6.136719 -14.390625 L 6.136719 0.988281 L 6.296875 0.988281 C 8.625 -1.800781 13.070312 -2.539062 13.070312 -6.136719 C 13.070312 -7.371094 12.152344 -8.359375 10.597656 -8.359375 Z M 6.824219 -0.300781 L 6.824219 -4.902344 C 7.777344 -6.632812 9.011719 -7.371094 9.910156 -7.371094 C 10.707031 -7.371094 11.324219 -6.914062 11.324219 -5.835938 C 11.324219 -3.386719 8.765625 -2.398438 6.824219 -0.300781 Z M 6.824219 -0.300781 "
  }))))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffd03c",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(247.821347, 60.685631)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 6.421875 -7.375 L 11.859375 -7.375 L 11.859375 -0.578125 C 10.378906 -0.078125 8.753906 0.171875 6.984375 0.171875 C 5.046875 0.171875 3.546875 -0.390625 2.484375 -1.515625 C 1.421875 -2.640625 0.890625 -4.242188 0.890625 -6.328125 C 0.890625 -8.359375 1.46875 -9.941406 2.625 -11.078125 C 3.789062 -12.210938 5.421875 -12.78125 7.515625 -12.78125 C 8.304688 -12.78125 9.050781 -12.703125 9.75 -12.546875 C 10.457031 -12.398438 11.070312 -12.210938 11.59375 -11.984375 L 10.515625 -9.3125 C 9.609375 -9.757812 8.613281 -9.984375 7.53125 -9.984375 C 6.53125 -9.984375 5.757812 -9.660156 5.21875 -9.015625 C 4.675781 -8.367188 4.40625 -7.445312 4.40625 -6.25 C 4.40625 -5.070312 4.648438 -4.171875 5.140625 -3.546875 C 5.640625 -2.929688 6.347656 -2.625 7.265625 -2.625 C 7.773438 -2.625 8.242188 -2.675781 8.671875 -2.78125 L 8.671875 -4.75 L 6.421875 -4.75 Z M 6.421875 -7.375 "
  }))))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffd03c",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(260.876514, 60.685631)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 13.402344 -9.292969 L 13.402344 -10.757812 L 11.023438 -10.421875 L 11.023438 -14.425781 L 10.335938 -14.425781 L 10.335938 -10.316406 L 7.25 -9.875 L 7.25 -13.878906 L 6.5625 -13.878906 L 6.5625 -9.769531 L 4.164062 -9.417969 L 4.164062 -7.9375 L 6.5625 -8.289062 L 6.5625 -4.671875 L 4.164062 -4.320312 L 4.164062 -2.855469 L 6.5625 -3.210938 L 6.5625 0.988281 L 7.25 0.988281 L 7.25 -3.316406 L 10.335938 -3.757812 L 10.335938 0.441406 L 11.023438 0.441406 L 11.023438 -3.863281 L 13.402344 -4.199219 L 13.402344 -5.679688 L 11.023438 -5.328125 L 11.023438 -8.941406 Z M 10.335938 -5.21875 L 7.25 -4.78125 L 7.25 -8.394531 L 10.335938 -8.835938 Z M 10.335938 -5.21875 "
  }))))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffd03c",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(299.612829, 60.685607)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 9.09375 0 L 8.46875 -2.359375 L 4.375 -2.359375 L 3.734375 0 L 0 0 L 4.109375 -12.640625 L 8.640625 -12.640625 L 12.8125 0 Z M 7.765625 -5.15625 L 7.21875 -7.21875 C 7.09375 -7.675781 6.9375 -8.269531 6.75 -9 C 6.570312 -9.726562 6.457031 -10.25 6.40625 -10.5625 C 6.351562 -10.269531 6.25 -9.785156 6.09375 -9.109375 C 5.9375 -8.441406 5.597656 -7.125 5.078125 -5.15625 Z M 7.765625 -5.15625 "
  }))))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffd03c",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(312.418259, 60.685607)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 13.402344 -9.292969 L 13.402344 -10.757812 L 11.023438 -10.421875 L 11.023438 -14.425781 L 10.335938 -14.425781 L 10.335938 -10.316406 L 7.25 -9.875 L 7.25 -13.878906 L 6.5625 -13.878906 L 6.5625 -9.769531 L 4.164062 -9.417969 L 4.164062 -7.9375 L 6.5625 -8.289062 L 6.5625 -4.671875 L 4.164062 -4.320312 L 4.164062 -2.855469 L 6.5625 -3.210938 L 6.5625 0.988281 L 7.25 0.988281 L 7.25 -3.316406 L 10.335938 -3.757812 L 10.335938 0.441406 L 11.023438 0.441406 L 11.023438 -3.863281 L 13.402344 -4.199219 L 13.402344 -5.679688 L 11.023438 -5.328125 L 11.023438 -8.941406 Z M 10.335938 -5.21875 L 7.25 -4.78125 L 7.25 -8.394531 L 10.335938 -8.835938 Z M 10.335938 -5.21875 "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiano);
export default __webpack_public_path__ + "static/media/piano.887206c3c7779cabd62b539bd7edb7d9.svg";
export { ForwardRef as ReactComponent };